
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0ecd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0ecd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hVi0X", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $d0c5bbd271a1a714$export$dca3b0875bd9a954; }, function (v) { return $d0c5bbd271a1a714$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $d0c5bbd271a1a714$export$16fa2f45be04daa8; }, function (v) { return $d0c5bbd271a1a714$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $d0c5bbd271a1a714$export$ffb0004e005737fa; }, function (v) { return $d0c5bbd271a1a714$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $d0c5bbd271a1a714$export$e2c29f18771995cb; }, function (v) { return $d0c5bbd271a1a714$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $d0c5bbd271a1a714$export$221d75b3f55bb0bd; }, function (v) { return $d0c5bbd271a1a714$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $d0c5bbd271a1a714$export$5f8d39834fd61797; }, function (v) { return $d0c5bbd271a1a714$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $d0c5bbd271a1a714$export$74bf444e3cd11ea5; }, function (v) { return $d0c5bbd271a1a714$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $d0c5bbd271a1a714$export$ae55be85d98224ed; }, function (v) { return $d0c5bbd271a1a714$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $d0c5bbd271a1a714$export$e530037191fcd5d7; }, function (v) { return $d0c5bbd271a1a714$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $d0c5bbd271a1a714$export$fd42f52fd3ae1109; }, function (v) { return $d0c5bbd271a1a714$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $d0c5bbd271a1a714$export$c8a8987d4410bf2d; }, function (v) { return $d0c5bbd271a1a714$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $d0c5bbd271a1a714$export$d38cd72104c1f0e9; }, function (v) { return $d0c5bbd271a1a714$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $d0c5bbd271a1a714$export$7d1e3a5e95ceca43; }, function (v) { return $d0c5bbd271a1a714$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $d0c5bbd271a1a714$export$257a8862b851cb5b; }, function (v) { return $d0c5bbd271a1a714$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $d0c5bbd271a1a714$export$a8257692ac88316c; }, function (v) { return $d0c5bbd271a1a714$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $d0c5bbd271a1a714$export$488013bae63b21da; }, function (v) { return $d0c5bbd271a1a714$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $d0c5bbd271a1a714$export$7c73462e0d25e514; }, function (v) { return $d0c5bbd271a1a714$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $d0c5bbd271a1a714$export$35808ee640e87ca7; }, function (v) { return $d0c5bbd271a1a714$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $d0c5bbd271a1a714$export$fae74005e78b1a27; }, function (v) { return $d0c5bbd271a1a714$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $d0c5bbd271a1a714$export$dc8fbce3eb94dc1e; }, function (v) { return $d0c5bbd271a1a714$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $d0c5bbd271a1a714$export$6d9c69b0de29b591; }, function (v) { return $d0c5bbd271a1a714$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $d0c5bbd271a1a714$export$d5a552a76deda3c2; }, function (v) { return $d0c5bbd271a1a714$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $d0c5bbd271a1a714$export$e5c5a5f917a5871c; }, function (v) { return $d0c5bbd271a1a714$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $d0c5bbd271a1a714$export$1538c33de8887b59; }, function (v) { return $d0c5bbd271a1a714$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $d0c5bbd271a1a714$export$13e3392192263954; }, function (v) { return $d0c5bbd271a1a714$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $d0c5bbd271a1a714$export$b8f5890fc79d6aca; }, function (v) { return $d0c5bbd271a1a714$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $d0c5bbd271a1a714$export$60241385465d0a34; }, function (v) { return $d0c5bbd271a1a714$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $d0c5bbd271a1a714$export$83d89fbfd8236492; }, function (v) { return $d0c5bbd271a1a714$export$83d89fbfd8236492 = v; });
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4aHdS = parcelRequire("4aHdS");
var $d0c5bbd271a1a714$export$dca3b0875bd9a954;
var $d0c5bbd271a1a714$export$16fa2f45be04daa8;
var $d0c5bbd271a1a714$export$ffb0004e005737fa;
var $d0c5bbd271a1a714$export$e2c29f18771995cb;
var $d0c5bbd271a1a714$export$221d75b3f55bb0bd;
var $d0c5bbd271a1a714$export$5f8d39834fd61797;
var $d0c5bbd271a1a714$export$74bf444e3cd11ea5;
var $d0c5bbd271a1a714$export$ae55be85d98224ed;
var $d0c5bbd271a1a714$export$e530037191fcd5d7;
var $d0c5bbd271a1a714$export$fd42f52fd3ae1109;
var $d0c5bbd271a1a714$export$c8a8987d4410bf2d;
var $d0c5bbd271a1a714$export$d38cd72104c1f0e9;
var $d0c5bbd271a1a714$export$7d1e3a5e95ceca43;
var $d0c5bbd271a1a714$export$257a8862b851cb5b;
var $d0c5bbd271a1a714$export$a8257692ac88316c;
var $d0c5bbd271a1a714$export$488013bae63b21da;
var $d0c5bbd271a1a714$export$7c73462e0d25e514;
var $d0c5bbd271a1a714$export$35808ee640e87ca7;
var $d0c5bbd271a1a714$export$fae74005e78b1a27;
var $d0c5bbd271a1a714$export$dc8fbce3eb94dc1e;
var $d0c5bbd271a1a714$export$6d9c69b0de29b591;
var $d0c5bbd271a1a714$export$d5a552a76deda3c2;
var $d0c5bbd271a1a714$export$e5c5a5f917a5871c;
var $d0c5bbd271a1a714$export$1538c33de8887b59;
var $d0c5bbd271a1a714$export$13e3392192263954;
var $d0c5bbd271a1a714$export$b8f5890fc79d6aca;
var $d0c5bbd271a1a714$export$60241385465d0a34;
var $d0c5bbd271a1a714$export$83d89fbfd8236492;
'use strict';

var $i1YR9 = parcelRequire("i1YR9");
var $d0c5bbd271a1a714$var$n = "function" === typeof Symbol && Symbol["for"], $d0c5bbd271a1a714$var$p = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.element") : 60103, $d0c5bbd271a1a714$var$q = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.portal") : 60106, $d0c5bbd271a1a714$var$r = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.fragment") : 60107, $d0c5bbd271a1a714$var$t = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.strict_mode") : 60108, $d0c5bbd271a1a714$var$u = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.profiler") : 60114, $d0c5bbd271a1a714$var$v = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.provider") : 60109, $d0c5bbd271a1a714$var$w = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.context") : 60110, $d0c5bbd271a1a714$var$x = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.forward_ref") : 60112, $d0c5bbd271a1a714$var$y = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.suspense") : 60113, $d0c5bbd271a1a714$var$z = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.memo") : 60115, $d0c5bbd271a1a714$var$A = $d0c5bbd271a1a714$var$n ? Symbol["for"]("react.lazy") : 60116, $d0c5bbd271a1a714$var$B = "function" === typeof Symbol && Symbol.iterator;
function $d0c5bbd271a1a714$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $d0c5bbd271a1a714$var$D = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $d0c5bbd271a1a714$var$E = {};
function $d0c5bbd271a1a714$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $d0c5bbd271a1a714$var$E;
    this.updater = c || $d0c5bbd271a1a714$var$D;
}
$d0c5bbd271a1a714$var$F.prototype.isReactComponent = {};
$d0c5bbd271a1a714$var$F.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && "function" !== typeof a && null != a) throw Error($d0c5bbd271a1a714$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$d0c5bbd271a1a714$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $d0c5bbd271a1a714$var$G() {}
$d0c5bbd271a1a714$var$G.prototype = $d0c5bbd271a1a714$var$F.prototype;
function $d0c5bbd271a1a714$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $d0c5bbd271a1a714$var$E;
    this.updater = c || $d0c5bbd271a1a714$var$D;
}
var $d0c5bbd271a1a714$var$I = $d0c5bbd271a1a714$var$H.prototype = new $d0c5bbd271a1a714$var$G;
$d0c5bbd271a1a714$var$I.constructor = $d0c5bbd271a1a714$var$H;
$i1YR9($d0c5bbd271a1a714$var$I, $d0c5bbd271a1a714$var$F.prototype);
$d0c5bbd271a1a714$var$I.isPureReactComponent = !0;
var $d0c5bbd271a1a714$var$J = {
    current: null
}, $d0c5bbd271a1a714$var$K = Object.prototype.hasOwnProperty, $d0c5bbd271a1a714$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d0c5bbd271a1a714$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$d0c5bbd271a1a714$var$K.call(b, e) && !$d0c5bbd271a1a714$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $d0c5bbd271a1a714$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $d0c5bbd271a1a714$var$J.current
    };
}
function $d0c5bbd271a1a714$var$N(a, b) {
    return {
        $$typeof: $d0c5bbd271a1a714$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $d0c5bbd271a1a714$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && null !== a && a.$$typeof === $d0c5bbd271a1a714$var$p;
}
function $d0c5bbd271a1a714$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $d0c5bbd271a1a714$var$P = /\/+/g, $d0c5bbd271a1a714$var$Q = [];
function $d0c5bbd271a1a714$var$R(a, b, c, e) {
    if ($d0c5bbd271a1a714$var$Q.length) {
        var d = $d0c5bbd271a1a714$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $d0c5bbd271a1a714$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $d0c5bbd271a1a714$var$Q.length && $d0c5bbd271a1a714$var$Q.push(a);
}
function $d0c5bbd271a1a714$var$T(a, b, c, e) {
    var d = typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a);
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $d0c5bbd271a1a714$var$p:
                case $d0c5bbd271a1a714$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $d0c5bbd271a1a714$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $d0c5bbd271a1a714$var$U(d, k);
        g += $d0c5bbd271a1a714$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) ? f = null : (f = $d0c5bbd271a1a714$var$B && a[$d0c5bbd271a1a714$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $d0c5bbd271a1a714$var$U(d, k++), g += $d0c5bbd271a1a714$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($d0c5bbd271a1a714$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $d0c5bbd271a1a714$var$V(a, b, c) {
    return null == a ? 0 : $d0c5bbd271a1a714$var$T(a, "", b, c);
}
function $d0c5bbd271a1a714$var$U(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && null !== a && null != a.key ? $d0c5bbd271a1a714$var$escape(a.key) : b.toString(36);
}
function $d0c5bbd271a1a714$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $d0c5bbd271a1a714$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $d0c5bbd271a1a714$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($d0c5bbd271a1a714$var$O(a) && (a = $d0c5bbd271a1a714$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($d0c5bbd271a1a714$var$P, "$&/") + "/") + c)), e.push(a));
}
function $d0c5bbd271a1a714$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($d0c5bbd271a1a714$var$P, "$&/") + "/");
    b = $d0c5bbd271a1a714$var$R(b, g, e, d);
    $d0c5bbd271a1a714$var$V(a, $d0c5bbd271a1a714$var$aa, b);
    $d0c5bbd271a1a714$var$S(b);
}
var $d0c5bbd271a1a714$var$Y = {
    current: null
};
function $d0c5bbd271a1a714$var$Z() {
    var a = $d0c5bbd271a1a714$var$Y.current;
    if (null === a) throw Error($d0c5bbd271a1a714$var$C(321));
    return a;
}
var $d0c5bbd271a1a714$var$ba = {
    ReactCurrentDispatcher: $d0c5bbd271a1a714$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $d0c5bbd271a1a714$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $i1YR9
};
$d0c5bbd271a1a714$export$dca3b0875bd9a954 = {
    map: function map(a, b, c) {
        if (null == a) return a;
        var e = [];
        $d0c5bbd271a1a714$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function forEach(a, b, c) {
        if (null == a) return a;
        b = $d0c5bbd271a1a714$var$R(null, null, b, c);
        $d0c5bbd271a1a714$var$V(a, $d0c5bbd271a1a714$var$W, b);
        $d0c5bbd271a1a714$var$S(b);
    },
    count: function count(a) {
        return $d0c5bbd271a1a714$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function toArray(a) {
        var b = [];
        $d0c5bbd271a1a714$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function only(a) {
        if (!$d0c5bbd271a1a714$var$O(a)) throw Error($d0c5bbd271a1a714$var$C(143));
        return a;
    }
};
$d0c5bbd271a1a714$export$16fa2f45be04daa8 = $d0c5bbd271a1a714$var$F;
$d0c5bbd271a1a714$export$ffb0004e005737fa = $d0c5bbd271a1a714$var$r;
$d0c5bbd271a1a714$export$e2c29f18771995cb = $d0c5bbd271a1a714$var$u;
$d0c5bbd271a1a714$export$221d75b3f55bb0bd = $d0c5bbd271a1a714$var$H;
$d0c5bbd271a1a714$export$5f8d39834fd61797 = $d0c5bbd271a1a714$var$t;
$d0c5bbd271a1a714$export$74bf444e3cd11ea5 = $d0c5bbd271a1a714$var$y;
$d0c5bbd271a1a714$export$ae55be85d98224ed = $d0c5bbd271a1a714$var$ba;
$d0c5bbd271a1a714$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($d0c5bbd271a1a714$var$C(267, a));
    var e = $i1YR9({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $d0c5bbd271a1a714$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$d0c5bbd271a1a714$var$K.call(b, h) && !$d0c5bbd271a1a714$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $d0c5bbd271a1a714$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$d0c5bbd271a1a714$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $d0c5bbd271a1a714$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $d0c5bbd271a1a714$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$d0c5bbd271a1a714$export$c8a8987d4410bf2d = $d0c5bbd271a1a714$var$M;
$d0c5bbd271a1a714$export$d38cd72104c1f0e9 = function(a) {
    var b = $d0c5bbd271a1a714$var$M.bind(null, a);
    b.type = a;
    return b;
};
$d0c5bbd271a1a714$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$d0c5bbd271a1a714$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $d0c5bbd271a1a714$var$x,
        render: a
    };
};
$d0c5bbd271a1a714$export$a8257692ac88316c = $d0c5bbd271a1a714$var$O;
$d0c5bbd271a1a714$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $d0c5bbd271a1a714$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$d0c5bbd271a1a714$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $d0c5bbd271a1a714$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$d0c5bbd271a1a714$export$35808ee640e87ca7 = function(a, b) {
    return $d0c5bbd271a1a714$var$Z().useCallback(a, b);
};
$d0c5bbd271a1a714$export$fae74005e78b1a27 = function(a, b) {
    return $d0c5bbd271a1a714$var$Z().useContext(a, b);
};
$d0c5bbd271a1a714$export$dc8fbce3eb94dc1e = function() {};
$d0c5bbd271a1a714$export$6d9c69b0de29b591 = function(a, b) {
    return $d0c5bbd271a1a714$var$Z().useEffect(a, b);
};
$d0c5bbd271a1a714$export$d5a552a76deda3c2 = function(a, b, c) {
    return $d0c5bbd271a1a714$var$Z().useImperativeHandle(a, b, c);
};
$d0c5bbd271a1a714$export$e5c5a5f917a5871c = function(a, b) {
    return $d0c5bbd271a1a714$var$Z().useLayoutEffect(a, b);
};
$d0c5bbd271a1a714$export$1538c33de8887b59 = function(a, b) {
    return $d0c5bbd271a1a714$var$Z().useMemo(a, b);
};
$d0c5bbd271a1a714$export$13e3392192263954 = function(a, b, c) {
    return $d0c5bbd271a1a714$var$Z().useReducer(a, b, c);
};
$d0c5bbd271a1a714$export$b8f5890fc79d6aca = function(a) {
    return $d0c5bbd271a1a714$var$Z().useRef(a);
};
$d0c5bbd271a1a714$export$60241385465d0a34 = function(a) {
    return $d0c5bbd271a1a714$var$Z().useState(a);
};
$d0c5bbd271a1a714$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("4aHdS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $30999fc3302ab3a7$export$71511d61b312f219; });
function $30999fc3302ab3a7$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("i1YR9", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $d20786cc12f1e66e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d20786cc12f1e66e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $d20786cc12f1e66e$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $d20786cc12f1e66e$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $d20786cc12f1e66e$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $d20786cc12f1e66e$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $d20786cc12f1e66e$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($d20786cc12f1e66e$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($d20786cc12f1e66e$var$getOwnPropertySymbols) {
            symbols = $d20786cc12f1e66e$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($d20786cc12f1e66e$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("5GLMR", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $4245f17cbe5a9125$export$2b8d127b894957b9; }, function (v) { return $4245f17cbe5a9125$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $4245f17cbe5a9125$export$cea3a54a6425200c; }, function (v) { return $4245f17cbe5a9125$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $4245f17cbe5a9125$export$a7c73072b1a182ae; }, function (v) { return $4245f17cbe5a9125$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $4245f17cbe5a9125$export$9f27bc3417b4524d; }, function (v) { return $4245f17cbe5a9125$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $4245f17cbe5a9125$export$db77ccec0bb4ccac; }, function (v) { return $4245f17cbe5a9125$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $4245f17cbe5a9125$export$8392c0c9d3dcbd35; }, function (v) { return $4245f17cbe5a9125$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $4245f17cbe5a9125$export$ffb0004e005737fa; }, function (v) { return $4245f17cbe5a9125$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $4245f17cbe5a9125$export$b624eff549462981; }, function (v) { return $4245f17cbe5a9125$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $4245f17cbe5a9125$export$7897aa7841a5380c; }, function (v) { return $4245f17cbe5a9125$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $4245f17cbe5a9125$export$602eac185826482c; }, function (v) { return $4245f17cbe5a9125$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $4245f17cbe5a9125$export$e2c29f18771995cb; }, function (v) { return $4245f17cbe5a9125$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $4245f17cbe5a9125$export$5f8d39834fd61797; }, function (v) { return $4245f17cbe5a9125$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $4245f17cbe5a9125$export$74bf444e3cd11ea5; }, function (v) { return $4245f17cbe5a9125$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $4245f17cbe5a9125$export$92387174baf9b227; }, function (v) { return $4245f17cbe5a9125$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $4245f17cbe5a9125$export$ec112efeb987d9c6; }, function (v) { return $4245f17cbe5a9125$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $4245f17cbe5a9125$export$b706b080d889d2c9; }, function (v) { return $4245f17cbe5a9125$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $4245f17cbe5a9125$export$5be5a87408f70ddc; }, function (v) { return $4245f17cbe5a9125$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $4245f17cbe5a9125$export$45a5e7f76e0caa8d; }, function (v) { return $4245f17cbe5a9125$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $4245f17cbe5a9125$export$455c2e768291efa6; }, function (v) { return $4245f17cbe5a9125$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $4245f17cbe5a9125$export$9522e17588c12572; }, function (v) { return $4245f17cbe5a9125$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $4245f17cbe5a9125$export$2110ac352bb060b9; }, function (v) { return $4245f17cbe5a9125$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $4245f17cbe5a9125$export$56885ab8b9c456ab; }, function (v) { return $4245f17cbe5a9125$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $4245f17cbe5a9125$export$d927fcb6adf8f9de; }, function (v) { return $4245f17cbe5a9125$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $4245f17cbe5a9125$export$b82d16f27459e05a; }, function (v) { return $4245f17cbe5a9125$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $4245f17cbe5a9125$export$522c17b4f5e123e8; }, function (v) { return $4245f17cbe5a9125$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $4245f17cbe5a9125$export$1aabd8a0274ecfd6; }, function (v) { return $4245f17cbe5a9125$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $4245f17cbe5a9125$export$9b621391a187a31a; }, function (v) { return $4245f17cbe5a9125$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $4245f17cbe5a9125$export$f5bbd400c2f4426f; }, function (v) { return $4245f17cbe5a9125$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4aHdS = parcelRequire("4aHdS");
var $4245f17cbe5a9125$export$2b8d127b894957b9;
var $4245f17cbe5a9125$export$cea3a54a6425200c;
var $4245f17cbe5a9125$export$a7c73072b1a182ae;
var $4245f17cbe5a9125$export$9f27bc3417b4524d;
var $4245f17cbe5a9125$export$db77ccec0bb4ccac;
var $4245f17cbe5a9125$export$8392c0c9d3dcbd35;
var $4245f17cbe5a9125$export$ffb0004e005737fa;
var $4245f17cbe5a9125$export$b624eff549462981;
var $4245f17cbe5a9125$export$7897aa7841a5380c;
var $4245f17cbe5a9125$export$602eac185826482c;
var $4245f17cbe5a9125$export$e2c29f18771995cb;
var $4245f17cbe5a9125$export$5f8d39834fd61797;
var $4245f17cbe5a9125$export$74bf444e3cd11ea5;
var $4245f17cbe5a9125$export$92387174baf9b227;
var $4245f17cbe5a9125$export$ec112efeb987d9c6;
var $4245f17cbe5a9125$export$b706b080d889d2c9;
var $4245f17cbe5a9125$export$5be5a87408f70ddc;
var $4245f17cbe5a9125$export$45a5e7f76e0caa8d;
var $4245f17cbe5a9125$export$455c2e768291efa6;
var $4245f17cbe5a9125$export$9522e17588c12572;
var $4245f17cbe5a9125$export$2110ac352bb060b9;
var $4245f17cbe5a9125$export$56885ab8b9c456ab;
var $4245f17cbe5a9125$export$d927fcb6adf8f9de;
var $4245f17cbe5a9125$export$b82d16f27459e05a;
var $4245f17cbe5a9125$export$522c17b4f5e123e8;
var $4245f17cbe5a9125$export$1aabd8a0274ecfd6;
var $4245f17cbe5a9125$export$9b621391a187a31a;
var $4245f17cbe5a9125$export$f5bbd400c2f4426f;
'use strict';
var $4245f17cbe5a9125$var$b = "function" === typeof Symbol && Symbol["for"], $4245f17cbe5a9125$var$c = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.element") : 60103, $4245f17cbe5a9125$var$d = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.portal") : 60106, $4245f17cbe5a9125$var$e = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.fragment") : 60107, $4245f17cbe5a9125$var$f = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.strict_mode") : 60108, $4245f17cbe5a9125$var$g = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.profiler") : 60114, $4245f17cbe5a9125$var$h = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.provider") : 60109, $4245f17cbe5a9125$var$k = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.context") : 60110, $4245f17cbe5a9125$var$l = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.async_mode") : 60111, $4245f17cbe5a9125$var$m = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.concurrent_mode") : 60111, $4245f17cbe5a9125$var$n = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.forward_ref") : 60112, $4245f17cbe5a9125$var$p = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.suspense") : 60113, $4245f17cbe5a9125$var$q = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.suspense_list") : 60120, $4245f17cbe5a9125$var$r = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.memo") : 60115, $4245f17cbe5a9125$var$t = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.lazy") : 60116, $4245f17cbe5a9125$var$v = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.block") : 60121, $4245f17cbe5a9125$var$w = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.fundamental") : 60117, $4245f17cbe5a9125$var$x = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.responder") : 60118, $4245f17cbe5a9125$var$y = $4245f17cbe5a9125$var$b ? Symbol["for"]("react.scope") : 60119;
function $4245f17cbe5a9125$var$z(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $4245f17cbe5a9125$var$c:
                switch(a = a.type, a){
                    case $4245f17cbe5a9125$var$l:
                    case $4245f17cbe5a9125$var$m:
                    case $4245f17cbe5a9125$var$e:
                    case $4245f17cbe5a9125$var$g:
                    case $4245f17cbe5a9125$var$f:
                    case $4245f17cbe5a9125$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $4245f17cbe5a9125$var$k:
                            case $4245f17cbe5a9125$var$n:
                            case $4245f17cbe5a9125$var$t:
                            case $4245f17cbe5a9125$var$r:
                            case $4245f17cbe5a9125$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $4245f17cbe5a9125$var$d:
                return u;
        }
    }
}
function $4245f17cbe5a9125$var$A(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$m;
}
$4245f17cbe5a9125$export$2b8d127b894957b9 = $4245f17cbe5a9125$var$l;
$4245f17cbe5a9125$export$cea3a54a6425200c = $4245f17cbe5a9125$var$m;
$4245f17cbe5a9125$export$a7c73072b1a182ae = $4245f17cbe5a9125$var$k;
$4245f17cbe5a9125$export$9f27bc3417b4524d = $4245f17cbe5a9125$var$h;
$4245f17cbe5a9125$export$db77ccec0bb4ccac = $4245f17cbe5a9125$var$c;
$4245f17cbe5a9125$export$8392c0c9d3dcbd35 = $4245f17cbe5a9125$var$n;
$4245f17cbe5a9125$export$ffb0004e005737fa = $4245f17cbe5a9125$var$e;
$4245f17cbe5a9125$export$b624eff549462981 = $4245f17cbe5a9125$var$t;
$4245f17cbe5a9125$export$7897aa7841a5380c = $4245f17cbe5a9125$var$r;
$4245f17cbe5a9125$export$602eac185826482c = $4245f17cbe5a9125$var$d;
$4245f17cbe5a9125$export$e2c29f18771995cb = $4245f17cbe5a9125$var$g;
$4245f17cbe5a9125$export$5f8d39834fd61797 = $4245f17cbe5a9125$var$f;
$4245f17cbe5a9125$export$74bf444e3cd11ea5 = $4245f17cbe5a9125$var$p;
$4245f17cbe5a9125$export$92387174baf9b227 = function(a) {
    return $4245f17cbe5a9125$var$A(a) || $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$l;
};
$4245f17cbe5a9125$export$ec112efeb987d9c6 = $4245f17cbe5a9125$var$A;
$4245f17cbe5a9125$export$b706b080d889d2c9 = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$k;
};
$4245f17cbe5a9125$export$5be5a87408f70ddc = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$h;
};
$4245f17cbe5a9125$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && null !== a && a.$$typeof === $4245f17cbe5a9125$var$c;
};
$4245f17cbe5a9125$export$455c2e768291efa6 = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$n;
};
$4245f17cbe5a9125$export$9522e17588c12572 = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$e;
};
$4245f17cbe5a9125$export$2110ac352bb060b9 = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$t;
};
$4245f17cbe5a9125$export$56885ab8b9c456ab = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$r;
};
$4245f17cbe5a9125$export$d927fcb6adf8f9de = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$d;
};
$4245f17cbe5a9125$export$b82d16f27459e05a = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$g;
};
$4245f17cbe5a9125$export$522c17b4f5e123e8 = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$f;
};
$4245f17cbe5a9125$export$1aabd8a0274ecfd6 = function(a) {
    return $4245f17cbe5a9125$var$z(a) === $4245f17cbe5a9125$var$p;
};
$4245f17cbe5a9125$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $4245f17cbe5a9125$var$e || a === $4245f17cbe5a9125$var$m || a === $4245f17cbe5a9125$var$g || a === $4245f17cbe5a9125$var$f || a === $4245f17cbe5a9125$var$p || a === $4245f17cbe5a9125$var$q || "object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && null !== a && (a.$$typeof === $4245f17cbe5a9125$var$t || a.$$typeof === $4245f17cbe5a9125$var$r || a.$$typeof === $4245f17cbe5a9125$var$h || a.$$typeof === $4245f17cbe5a9125$var$k || a.$$typeof === $4245f17cbe5a9125$var$n || a.$$typeof === $4245f17cbe5a9125$var$w || a.$$typeof === $4245f17cbe5a9125$var$x || a.$$typeof === $4245f17cbe5a9125$var$y || a.$$typeof === $4245f17cbe5a9125$var$v);
};
$4245f17cbe5a9125$export$f5bbd400c2f4426f = $4245f17cbe5a9125$var$z;

});

parcelRegister("a4jUf", function(module, exports) {

$parcel$export(module.exports, "createRule", function () { return createRule; });
$parcel$export(module.exports, "toCssValue", function () { return toCssValue; });
$parcel$export(module.exports, "RuleList", function () { return RuleList; });
$parcel$export(module.exports, "create", function () { return createJss; });
$parcel$export(module.exports, "hasCSSTOMSupport", function () { return hasCSSTOMSupport; });
$parcel$export(module.exports, "getDynamicStyles", function () { return getDynamicStyles; });

var $4aHdS = parcelRequire("4aHdS");

var $kdVxI = parcelRequire("kdVxI");

var $1dEZ1 = parcelRequire("1dEZ1");

var $60rzb = parcelRequire("60rzb");

var $81HPe = parcelRequire("81HPe");

var $838FQ = parcelRequire("838FQ");

var $4uKYT = parcelRequire("4uKYT");

var $hvJMu = parcelRequire("hvJMu");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || (typeof style === "undefined" ? "undefined" : (0, $4aHdS._)(style)) !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function escape(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $838FQ.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $4uKYT.default)((0, $4uKYT.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    };
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if ((typeof value === "undefined" ? "undefined" : (0, $4aHdS._)(value)) !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    };
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kdVxI.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $81HPe.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $kdVxI.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $kdVxI.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $kdVxI.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $838FQ.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $kdVxI.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $kdVxI.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    };
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $kdVxI.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    };
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    };
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    };
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    };
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    };
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    };
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    };
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    };
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $kdVxI.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    };
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    };
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    };
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    };
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    };
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    };
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    };
    _proto.deleteRule = function deleteRule(name) {
        var rule = (typeof name === "undefined" ? "undefined" : (0, $4aHdS._)(name)) === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    };
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    };
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    };
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    };
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    };
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    };
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    };
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    };
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    };
    _proto.reset = function reset() {
        this.registry = [];
    };
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    };
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $hvJMu.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $81HPe.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap["delete"](prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    };
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    };
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    };
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    };
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    };
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    };
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    };
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    };
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $1dEZ1.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $kdVxI.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    };
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $kdVxI.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    };
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    };
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if ((typeof name === "undefined" ? "undefined" : (0, $4aHdS._)(name)) === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $kdVxI.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $60rzb.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $60rzb.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $81HPe.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = (typeof CSS === "undefined" ? "undefined" : (0, $4aHdS._)(CSS)) === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value === "undefined" ? "undefined" : (0, $4aHdS._)(value);
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $7549b810aa31c0bb$export$2e2bcd8739ae039 = index;

});
parcelRegister("kdVxI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb91a85e81eb4162$export$2e2bcd8739ae039; });
function $eb91a85e81eb4162$export$2e2bcd8739ae039() {
    $eb91a85e81eb4162$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eb91a85e81eb4162$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("1dEZ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e36cbc2aad4caad$export$2e2bcd8739ae039; });

var $4aHdS = parcelRequire("4aHdS");
var $0e36cbc2aad4caad$var$_typeof = typeof Symbol === "function" && (0, $4aHdS._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $4aHdS._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $4aHdS._)(obj);
};
var $0e36cbc2aad4caad$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $0e36cbc2aad4caad$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $0e36cbc2aad4caad$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $0e36cbc2aad4caad$export$2e2bcd8739ae039 = $0e36cbc2aad4caad$export$4e09c449d6c407f7;

});

parcelRegister("60rzb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45f8204ec0bdaf1d$export$2e2bcd8739ae039; });
var $45f8204ec0bdaf1d$var$isProduction = true;
function $45f8204ec0bdaf1d$var$warning(condition, message) {
    if (!$45f8204ec0bdaf1d$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $45f8204ec0bdaf1d$export$2e2bcd8739ae039 = $45f8204ec0bdaf1d$var$warning;

});

parcelRegister("81HPe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d8069892c43dad2$export$2e2bcd8739ae039; });
function $5d8069892c43dad2$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5d8069892c43dad2$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $5d8069892c43dad2$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5d8069892c43dad2$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("838FQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dc5550354fd9cdb$export$2e2bcd8739ae039; });

var $gNQAU = parcelRequire("gNQAU");
function $5dc5550354fd9cdb$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $gNQAU.default)(subClass, superClass);
}

});
parcelRegister("gNQAU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c3ba05119bf1f4db$export$2e2bcd8739ae039; });
function $c3ba05119bf1f4db$export$2e2bcd8739ae039(o, p) {
    $c3ba05119bf1f4db$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c3ba05119bf1f4db$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("4uKYT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $345e6843e3906228$export$2e2bcd8739ae039; });
function $345e6843e3906228$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("hvJMu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbf8d81b9140d8e6$export$2e2bcd8739ae039; });
function $cbf8d81b9140d8e6$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("c90Mh", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $4aHdS = parcelRequire("4aHdS");
'use strict';

var $avTgU = parcelRequire("avTgU");

var $i1YR9 = parcelRequire("i1YR9");

var $7P3WW = parcelRequire("7P3WW");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$avTgU) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function onError(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $4aHdS._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $avTgU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol["for"], Za = E ? Symbol["for"]("react.element") : 60103, $a = E ? Symbol["for"]("react.portal") : 60106, ab = E ? Symbol["for"]("react.fragment") : 60107, bb = E ? Symbol["for"]("react.strict_mode") : 60108, cb = E ? Symbol["for"]("react.profiler") : 60114, db = E ? Symbol["for"]("react.provider") : 60109, eb = E ? Symbol["for"]("react.context") : 60110, fb = E ? Symbol["for"]("react.concurrent_mode") : 60111, gb = E ? Symbol["for"]("react.forward_ref") : 60112, hb = E ? Symbol["for"]("react.suspense") : 60113, ib = E ? Symbol["for"]("react.suspense_list") : 60120, jb = E ? Symbol["for"]("react.memo") : 60115, kb = E ? Symbol["for"]("react.lazy") : 60116, lb = E ? Symbol["for"]("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a))) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b["default"], a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a))) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a["return"];
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $i1YR9({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $avTgU.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $i1YR9({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $i1YR9({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b["return"];)b = b["return"];
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b["return"]), a = b["return"];
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c["return"];
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e["return"];
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c["return"] !== d["return"]) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child["return"] = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b["return"] || b["return"] === a) return null;
                b = b["return"];
            }
            b.sibling["return"] = b["return"];
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d["return"];)d = d["return"];
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec["delete"](b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc["delete"](b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $7P3WW.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c["delete"](b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $7P3WW.unstable_scheduleCallback($7P3WW.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $7P3WW.unstable_UserBlockingPriority, ed = $7P3WW.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $i1YR9({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === (0, $4aHdS._)(b.dangerouslySetInnerHTML) && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== (0, $4aHdS._)(b.style)) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $4aHdS._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a["return"];
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c === "undefined" ? "undefined" : (0, $4aHdS._)(c)));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$i1YR9(G.prototype, {
    preventDefault: function preventDefault() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $4aHdS._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function stopPropagation() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $4aHdS._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function persist() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function destructor() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function currentTarget() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $i1YR9(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $i1YR9({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b["char"] && 1 < b["char"].length) return b["char"];
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function extractEvents(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function extractEvents(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function relatedTarget(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function movementY(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function extractEvents(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $4aHdS._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function extractEvents(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function key(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function charCode(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function extractEvents(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $i1YR9({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $7P3WW.unstable_runWithPriority, Jf = $7P3WW.unstable_scheduleCallback, Kf = $7P3WW.unstable_cancelCallback, Lf = $7P3WW.unstable_requestPaint, Mf = $7P3WW.unstable_now, Nf = $7P3WW.unstable_getCurrentPriorityLevel, Of = $7P3WW.unstable_ImmediatePriority, Pf = $7P3WW.unstable_UserBlockingPriority, Qf = $7P3WW.unstable_NormalPriority, Rf = $7P3WW.unstable_LowPriority, Sf = $7P3WW.unstable_IdlePriority, Tf = {}, Uf = $7P3WW.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function Vf() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function $f() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var _$c = b[a];
                    do _$c = _$c(!0);
                    while (null !== _$c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $i1YR9({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a["return"];
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $i1YR9({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $avTgU.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $i1YR9({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $4aHdS._)(f)) && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $4aHdS._)(f)) && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function b(a) {
                var _$b = d.refs;
                _$b === Eg && (_$b = d.refs = {});
                null === a ? delete _$b[e] : _$b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d["return"] = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d["return"] = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b["return"] = a, b;
        b = e(b, c.children || []);
        b["return"] = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b["return"] = a, b;
        b = e(b, c);
        b["return"] = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b["return"] = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $4aHdS._)(b)) && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c["return"] = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b["return"] = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b["return"] = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $4aHdS._)(c)) && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $4aHdS._)(d)) && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m["delete"](null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t["delete"](null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === (typeof f === "undefined" ? "undefined" : (0, $4aHdS._)(f)) && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === (typeof f === "undefined" ? "undefined" : (0, $4aHdS._)(f)) && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d["return"] = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d["return"] = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d["return"] = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h["return"] = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d["return"] = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d["return"] = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d["return"] = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d["return"] = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child["return"] = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b["return"] || b["return"] === a) return null;
            b = b["return"];
        }
        b.sibling["return"] = b["return"];
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function useTransition(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function useState() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function useTransition(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function useState() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function useDeferredValue(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function useTransition(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c["return"] = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a["return"];
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a["return"] = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a["return"] = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $4aHdS._)(l)) && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === (typeof l === "undefined" ? "undefined" : (0, $4aHdS._)(l)) && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e["return"] = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a["return"] = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c["return"] = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c["return"] = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g["return"] = c, g = g.sibling;
            d = Sg(d, e);
            d["return"] = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e["return"] = b;
        e.child = a;
        null !== a && (a["return"] = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a["return"] = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c["return"] = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a["return"], b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child["return"] = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a["return"] || a["return"] === b) break a;
                a = a["return"];
            }
            a.sibling["return"] = a["return"];
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c["return"] = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c["return"] = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function ni(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child["return"] = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c["return"] || c["return"] === b) return;
            c = c["return"];
        }
        c.sibling["return"] = c["return"];
        c = c.sibling;
    }
};
oi = function oi() {};
pi = function pi(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $i1YR9({}, f, {
                    value: void 0
                });
                d = $i1YR9({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function qi(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $i1YR9({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var _$a = d;
                    do {
                        var _$c = _$a.destroy;
                        if (void 0 !== _$c) {
                            var g = b;
                            try {
                                _$c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        _$a = _$a.next;
                    }while (_$a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a["return"] = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a["return"]; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b["return"];
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c["return"] || Oi(c["return"])) {
                c = null;
                break a;
            }
            c = c["return"];
        }
        c.sibling["return"] = c["return"];
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child["return"] = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d["return"];
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e["return"];
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child["return"] = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m["return"] || m["return"] === k) break a;
                    m = m["return"];
                }
                m.sibling["return"] = m["return"];
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child["return"] = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child["return"] = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d["return"] || d["return"] === b) return;
            d = d["return"];
            4 === d.tag && (e = !1);
        }
        d.sibling["return"] = d["return"];
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f["return"] = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child["return"] = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a["return"] || a["return"] === c) break a;
                    a = a["return"];
                }
                a.sibling["return"] = a["return"];
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a["return"], e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d["return"] && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d["return"];
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X["return"]; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c["return"];
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X["return"]) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X["return"], g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === (typeof h === "undefined" ? "undefined" : (0, $4aHdS._)(h)) && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p["return"];
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p["return"];
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X["return"];
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a["return"]; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c["return"];
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d["delete"](b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c["delete"](b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function Rj(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === (typeof e === "undefined" ? "undefined" : (0, $4aHdS._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h["return"] = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h["return"], c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g["return"] = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h["return"] = g["return"];
                                g = h;
                                break;
                            }
                            g = g["return"];
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function Uj(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function Li(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this["return"] = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a)) && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $4aHdS._)(a), ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h["return"];
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = ck(g);
                h.call(_$a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function e() {
                var _$a = ck(g);
                k.call(_$a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function wc(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function xc(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function yc(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function za(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function Ga(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function Ha() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function Ia(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($i1YR9({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function findHostInstanceByFiber(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function findFiberByHostInstance(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("avTgU", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hVi0X"));

});

parcelRegister("7P3WW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hEmwJ"));

});
parcelRegister("hEmwJ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $cd97a57d11b73e35$export$c4744153514ff05d; }, function (v) { return $cd97a57d11b73e35$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $cd97a57d11b73e35$export$d66a1c1c77bd778b; }, function (v) { return $cd97a57d11b73e35$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $cd97a57d11b73e35$export$3e506c1ccc9cc1a7; }, function (v) { return $cd97a57d11b73e35$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $cd97a57d11b73e35$export$e26fe2ed2fa76875; }, function (v) { return $cd97a57d11b73e35$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $cd97a57d11b73e35$export$502329bbf4b505b1; }, function (v) { return $cd97a57d11b73e35$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $cd97a57d11b73e35$export$6e3807111c4874c4; }, function (v) { return $cd97a57d11b73e35$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $cd97a57d11b73e35$export$c27134553091fb3a; }, function (v) { return $cd97a57d11b73e35$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $cd97a57d11b73e35$export$33ee1acdc04fd2a2; }, function (v) { return $cd97a57d11b73e35$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $cd97a57d11b73e35$export$b00a404bbd5edef2; }, function (v) { return $cd97a57d11b73e35$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $cd97a57d11b73e35$export$8352ce38b91d0c62; }, function (v) { return $cd97a57d11b73e35$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $cd97a57d11b73e35$export$d3dfb8e4810cb555; }, function (v) { return $cd97a57d11b73e35$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $cd97a57d11b73e35$export$839f9183b0465a69; }, function (v) { return $cd97a57d11b73e35$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $cd97a57d11b73e35$export$72fdf0e06517287b; }, function (v) { return $cd97a57d11b73e35$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $cd97a57d11b73e35$export$4b844e58a3e414b4; }, function (v) { return $cd97a57d11b73e35$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $cd97a57d11b73e35$export$816d2913ae6b83b1; }, function (v) { return $cd97a57d11b73e35$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $cd97a57d11b73e35$export$61bcfe829111a1d0; }, function (v) { return $cd97a57d11b73e35$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $cd97a57d11b73e35$export$7ee8c9beb337bc3f; }, function (v) { return $cd97a57d11b73e35$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $cd97a57d11b73e35$export$b5836b71941fa3ed; }, function (v) { return $cd97a57d11b73e35$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $cd97a57d11b73e35$export$cf845f2c119da08a; }, function (v) { return $cd97a57d11b73e35$export$cf845f2c119da08a = v; });
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4aHdS = parcelRequire("4aHdS");
var $cd97a57d11b73e35$export$c4744153514ff05d;
var $cd97a57d11b73e35$export$d66a1c1c77bd778b;
var $cd97a57d11b73e35$export$3e506c1ccc9cc1a7;
var $cd97a57d11b73e35$export$e26fe2ed2fa76875;
var $cd97a57d11b73e35$export$502329bbf4b505b1;
var $cd97a57d11b73e35$export$6e3807111c4874c4;
var $cd97a57d11b73e35$export$c27134553091fb3a;
var $cd97a57d11b73e35$export$33ee1acdc04fd2a2;
var $cd97a57d11b73e35$export$b00a404bbd5edef2;
var $cd97a57d11b73e35$export$8352ce38b91d0c62;
var $cd97a57d11b73e35$export$d3dfb8e4810cb555;
var $cd97a57d11b73e35$export$839f9183b0465a69;
var $cd97a57d11b73e35$export$72fdf0e06517287b;
var $cd97a57d11b73e35$export$4b844e58a3e414b4;
var $cd97a57d11b73e35$export$816d2913ae6b83b1;
var $cd97a57d11b73e35$export$61bcfe829111a1d0;
var $cd97a57d11b73e35$export$7ee8c9beb337bc3f;
var $cd97a57d11b73e35$export$b5836b71941fa3ed;
var $cd97a57d11b73e35$export$cf845f2c119da08a;
'use strict';
var $cd97a57d11b73e35$var$f, $cd97a57d11b73e35$var$g, $cd97a57d11b73e35$var$h, $cd97a57d11b73e35$var$k, $cd97a57d11b73e35$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $cd97a57d11b73e35$var$p = null, $cd97a57d11b73e35$var$q = null, $cd97a57d11b73e35$var$t = function t1() {
        if (null !== $cd97a57d11b73e35$var$p) try {
            var a = $cd97a57d11b73e35$export$c4744153514ff05d();
            $cd97a57d11b73e35$var$p(!0, a);
            $cd97a57d11b73e35$var$p = null;
        } catch (b) {
            throw setTimeout($cd97a57d11b73e35$var$t, 0), b;
        }
    }, $cd97a57d11b73e35$var$u = Date.now();
    $cd97a57d11b73e35$export$c4744153514ff05d = function() {
        return Date.now() - $cd97a57d11b73e35$var$u;
    };
    $cd97a57d11b73e35$var$f = function(a) {
        null !== $cd97a57d11b73e35$var$p ? setTimeout($cd97a57d11b73e35$var$f, 0, a) : ($cd97a57d11b73e35$var$p = a, setTimeout($cd97a57d11b73e35$var$t, 0));
    };
    $cd97a57d11b73e35$var$g = function g(a, b) {
        $cd97a57d11b73e35$var$q = setTimeout(a, b);
    };
    $cd97a57d11b73e35$var$h = function h() {
        clearTimeout($cd97a57d11b73e35$var$q);
    };
    $cd97a57d11b73e35$var$k = function k() {
        return !1;
    };
    $cd97a57d11b73e35$var$l = $cd97a57d11b73e35$export$d66a1c1c77bd778b = function l() {};
} else {
    var $cd97a57d11b73e35$var$w = window.performance, $cd97a57d11b73e35$var$x = window.Date, $cd97a57d11b73e35$var$y = window.setTimeout, $cd97a57d11b73e35$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $cd97a57d11b73e35$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $cd97a57d11b73e35$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === (typeof $cd97a57d11b73e35$var$w === "undefined" ? "undefined" : (0, $4aHdS._)($cd97a57d11b73e35$var$w)) && "function" === typeof $cd97a57d11b73e35$var$w.now) $cd97a57d11b73e35$export$c4744153514ff05d = function() {
        return $cd97a57d11b73e35$var$w.now();
    };
    else {
        var $cd97a57d11b73e35$var$B = $cd97a57d11b73e35$var$x.now();
        $cd97a57d11b73e35$export$c4744153514ff05d = function() {
            return $cd97a57d11b73e35$var$x.now() - $cd97a57d11b73e35$var$B;
        };
    }
    var $cd97a57d11b73e35$var$C = !1, $cd97a57d11b73e35$var$D = null, $cd97a57d11b73e35$var$E = -1, $cd97a57d11b73e35$var$F = 5, $cd97a57d11b73e35$var$G = 0;
    $cd97a57d11b73e35$var$k = function k() {
        return $cd97a57d11b73e35$export$c4744153514ff05d() >= $cd97a57d11b73e35$var$G;
    };
    $cd97a57d11b73e35$var$l = function l() {};
    $cd97a57d11b73e35$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $cd97a57d11b73e35$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $cd97a57d11b73e35$var$H = new MessageChannel, $cd97a57d11b73e35$var$I = $cd97a57d11b73e35$var$H.port2;
    $cd97a57d11b73e35$var$H.port1.onmessage = function() {
        if (null !== $cd97a57d11b73e35$var$D) {
            var a = $cd97a57d11b73e35$export$c4744153514ff05d();
            $cd97a57d11b73e35$var$G = a + $cd97a57d11b73e35$var$F;
            try {
                $cd97a57d11b73e35$var$D(!0, a) ? $cd97a57d11b73e35$var$I.postMessage(null) : ($cd97a57d11b73e35$var$C = !1, $cd97a57d11b73e35$var$D = null);
            } catch (b) {
                throw $cd97a57d11b73e35$var$I.postMessage(null), b;
            }
        } else $cd97a57d11b73e35$var$C = !1;
    };
    $cd97a57d11b73e35$var$f = function f(a) {
        $cd97a57d11b73e35$var$D = a;
        $cd97a57d11b73e35$var$C || ($cd97a57d11b73e35$var$C = !0, $cd97a57d11b73e35$var$I.postMessage(null));
    };
    $cd97a57d11b73e35$var$g = function g(a, b) {
        $cd97a57d11b73e35$var$E = $cd97a57d11b73e35$var$y(function() {
            a($cd97a57d11b73e35$export$c4744153514ff05d());
        }, b);
    };
    $cd97a57d11b73e35$var$h = function h() {
        $cd97a57d11b73e35$var$z($cd97a57d11b73e35$var$E);
        $cd97a57d11b73e35$var$E = -1;
    };
}
function $cd97a57d11b73e35$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $cd97a57d11b73e35$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $cd97a57d11b73e35$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $cd97a57d11b73e35$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $cd97a57d11b73e35$var$K(n, c)) void 0 !== r && 0 > $cd97a57d11b73e35$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $cd97a57d11b73e35$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $cd97a57d11b73e35$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $cd97a57d11b73e35$var$N = [], $cd97a57d11b73e35$var$O = [], $cd97a57d11b73e35$var$P = 1, $cd97a57d11b73e35$var$Q = null, $cd97a57d11b73e35$var$R = 3, $cd97a57d11b73e35$var$S = !1, $cd97a57d11b73e35$var$T = !1, $cd97a57d11b73e35$var$U = !1;
function $cd97a57d11b73e35$var$V(a) {
    for(var b = $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$O); null !== b;){
        if (null === b.callback) $cd97a57d11b73e35$var$M($cd97a57d11b73e35$var$O);
        else if (b.startTime <= a) $cd97a57d11b73e35$var$M($cd97a57d11b73e35$var$O), b.sortIndex = b.expirationTime, $cd97a57d11b73e35$var$J($cd97a57d11b73e35$var$N, b);
        else break;
        b = $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$O);
    }
}
function $cd97a57d11b73e35$var$W(a) {
    $cd97a57d11b73e35$var$U = !1;
    $cd97a57d11b73e35$var$V(a);
    if (!$cd97a57d11b73e35$var$T) {
        if (null !== $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$N)) $cd97a57d11b73e35$var$T = !0, $cd97a57d11b73e35$var$f($cd97a57d11b73e35$var$X);
        else {
            var b = $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$O);
            null !== b && $cd97a57d11b73e35$var$g($cd97a57d11b73e35$var$W, b.startTime - a);
        }
    }
}
function $cd97a57d11b73e35$var$X(a, b) {
    $cd97a57d11b73e35$var$T = !1;
    $cd97a57d11b73e35$var$U && ($cd97a57d11b73e35$var$U = !1, $cd97a57d11b73e35$var$h());
    $cd97a57d11b73e35$var$S = !0;
    var c = $cd97a57d11b73e35$var$R;
    try {
        $cd97a57d11b73e35$var$V(b);
        for($cd97a57d11b73e35$var$Q = $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$N); null !== $cd97a57d11b73e35$var$Q && (!($cd97a57d11b73e35$var$Q.expirationTime > b) || a && !$cd97a57d11b73e35$var$k());){
            var d = $cd97a57d11b73e35$var$Q.callback;
            if (null !== d) {
                $cd97a57d11b73e35$var$Q.callback = null;
                $cd97a57d11b73e35$var$R = $cd97a57d11b73e35$var$Q.priorityLevel;
                var e = d($cd97a57d11b73e35$var$Q.expirationTime <= b);
                b = $cd97a57d11b73e35$export$c4744153514ff05d();
                "function" === typeof e ? $cd97a57d11b73e35$var$Q.callback = e : $cd97a57d11b73e35$var$Q === $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$N) && $cd97a57d11b73e35$var$M($cd97a57d11b73e35$var$N);
                $cd97a57d11b73e35$var$V(b);
            } else $cd97a57d11b73e35$var$M($cd97a57d11b73e35$var$N);
            $cd97a57d11b73e35$var$Q = $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$N);
        }
        if (null !== $cd97a57d11b73e35$var$Q) var m = !0;
        else {
            var n = $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$O);
            null !== n && $cd97a57d11b73e35$var$g($cd97a57d11b73e35$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $cd97a57d11b73e35$var$Q = null, $cd97a57d11b73e35$var$R = c, $cd97a57d11b73e35$var$S = !1;
    }
}
function $cd97a57d11b73e35$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $cd97a57d11b73e35$var$Z = $cd97a57d11b73e35$var$l;
$cd97a57d11b73e35$export$3e506c1ccc9cc1a7 = 5;
$cd97a57d11b73e35$export$e26fe2ed2fa76875 = 1;
$cd97a57d11b73e35$export$502329bbf4b505b1 = 4;
$cd97a57d11b73e35$export$6e3807111c4874c4 = 3;
$cd97a57d11b73e35$export$c27134553091fb3a = null;
$cd97a57d11b73e35$export$33ee1acdc04fd2a2 = 2;
$cd97a57d11b73e35$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$cd97a57d11b73e35$export$8352ce38b91d0c62 = function() {
    $cd97a57d11b73e35$var$T || $cd97a57d11b73e35$var$S || ($cd97a57d11b73e35$var$T = !0, $cd97a57d11b73e35$var$f($cd97a57d11b73e35$var$X));
};
$cd97a57d11b73e35$export$d3dfb8e4810cb555 = function() {
    return $cd97a57d11b73e35$var$R;
};
$cd97a57d11b73e35$export$839f9183b0465a69 = function() {
    return $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$N);
};
$cd97a57d11b73e35$export$72fdf0e06517287b = function(a) {
    switch($cd97a57d11b73e35$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $cd97a57d11b73e35$var$R;
    }
    var c = $cd97a57d11b73e35$var$R;
    $cd97a57d11b73e35$var$R = b;
    try {
        return a();
    } finally{
        $cd97a57d11b73e35$var$R = c;
    }
};
$cd97a57d11b73e35$export$4b844e58a3e414b4 = function() {};
$cd97a57d11b73e35$export$816d2913ae6b83b1 = $cd97a57d11b73e35$var$Z;
$cd97a57d11b73e35$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $cd97a57d11b73e35$var$R;
    $cd97a57d11b73e35$var$R = a;
    try {
        return b();
    } finally{
        $cd97a57d11b73e35$var$R = c;
    }
};
$cd97a57d11b73e35$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $cd97a57d11b73e35$export$c4744153514ff05d();
    if ("object" === (typeof c === "undefined" ? "undefined" : (0, $4aHdS._)(c)) && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $cd97a57d11b73e35$var$Y(a);
    } else c = $cd97a57d11b73e35$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $cd97a57d11b73e35$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $cd97a57d11b73e35$var$J($cd97a57d11b73e35$var$O, a), null === $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$N) && a === $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$O) && ($cd97a57d11b73e35$var$U ? $cd97a57d11b73e35$var$h() : $cd97a57d11b73e35$var$U = !0, $cd97a57d11b73e35$var$g($cd97a57d11b73e35$var$W, e - d))) : (a.sortIndex = c, $cd97a57d11b73e35$var$J($cd97a57d11b73e35$var$N, a), $cd97a57d11b73e35$var$T || $cd97a57d11b73e35$var$S || ($cd97a57d11b73e35$var$T = !0, $cd97a57d11b73e35$var$f($cd97a57d11b73e35$var$X)));
    return a;
};
$cd97a57d11b73e35$export$b5836b71941fa3ed = function() {
    var a = $cd97a57d11b73e35$export$c4744153514ff05d();
    $cd97a57d11b73e35$var$V(a);
    var b = $cd97a57d11b73e35$var$L($cd97a57d11b73e35$var$N);
    return b !== $cd97a57d11b73e35$var$Q && null !== $cd97a57d11b73e35$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $cd97a57d11b73e35$var$Q.expirationTime || $cd97a57d11b73e35$var$k();
};
$cd97a57d11b73e35$export$cf845f2c119da08a = function(a) {
    var b = $cd97a57d11b73e35$var$R;
    return function() {
        var c = $cd97a57d11b73e35$var$R;
        $cd97a57d11b73e35$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $cd97a57d11b73e35$var$R = c;
        }
    };
};

});



function $ab9acc49883b316d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $ab9acc49883b316d$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $ab9acc49883b316d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $ab9acc49883b316d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $cbdf5c16e62165d0$export$71511d61b312f219(o) {
    $cbdf5c16e62165d0$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cbdf5c16e62165d0$export$71511d61b312f219(o);
}


function $79f1847e93ba1dea$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($79f1847e93ba1dea$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $214b3b79bc7b30e6$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $4aHdS = parcelRequire("4aHdS");
function $6e41a331d5a8798e$export$71511d61b312f219(self, call) {
    if (call && ((0, $4aHdS._)(call) === "object" || typeof call === "function")) return call;
    return (0, $214b3b79bc7b30e6$export$71511d61b312f219)(self);
}


function $74c4af31b578e7d9$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $cbdf5c16e62165d0$export$71511d61b312f219)(derived);
    return (0, $6e41a331d5a8798e$export$71511d61b312f219)(_this, (0, $79f1847e93ba1dea$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $cbdf5c16e62165d0$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $26f837ee4ed2baf2$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $5ae6d0425b58687e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5ae6d0425b58687e$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $5ae6d0425b58687e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5ae6d0425b58687e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $95f600d7dc061357$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $938e5a0e7306ab94$export$71511d61b312f219(o, p) {
    $938e5a0e7306ab94$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $938e5a0e7306ab94$export$71511d61b312f219(o, p);
}


function $ab43615bc785b3d2$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $938e5a0e7306ab94$export$71511d61b312f219)(subClass, superClass);
}


function $56694a0b8260f85d$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


function $cf37ff95b85fc0f9$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $de52adba366158be$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $cf37ff95b85fc0f9$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


function $1223d5492c6f7a02$export$2e2bcd8739ae039() {
    return $1223d5492c6f7a02$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $1223d5492c6f7a02$export$2e2bcd8739ae039.apply(null, arguments);
}



var $avTgU = parcelRequire("avTgU");


var $4aHdS = parcelRequire("4aHdS");
function $f3c76fa91a7d4fc8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, $4aHdS._)(e))) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $f3c76fa91a7d4fc8$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $f3c76fa91a7d4fc8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $f3c76fa91a7d4fc8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f3c76fa91a7d4fc8$export$2e2bcd8739ae039 = $f3c76fa91a7d4fc8$export$4f5d2d50c9deca37;



function $5a5e3108410ead6b$export$2e2bcd8739ae039() {
    return $5a5e3108410ead6b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a5e3108410ead6b$export$2e2bcd8739ae039.apply(null, arguments);
}


function $5561eb57d8959b58$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $859833b6c80a41a3$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $5561eb57d8959b58$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $avTgU = parcelRequire("avTgU");

var $460f8d0446813630$exports = {};
'use strict';
var $cf60cbf4eccd6235$exports = {};
'use strict';

$cf60cbf4eccd6235$exports = (parcelRequire("5GLMR"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $460f8d0446813630$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $460f8d0446813630$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $460f8d0446813630$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $460f8d0446813630$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $460f8d0446813630$var$TYPE_STATICS = {};
$460f8d0446813630$var$TYPE_STATICS[$cf60cbf4eccd6235$exports.ForwardRef] = $460f8d0446813630$var$FORWARD_REF_STATICS;
$460f8d0446813630$var$TYPE_STATICS[$cf60cbf4eccd6235$exports.Memo] = $460f8d0446813630$var$MEMO_STATICS;
function $460f8d0446813630$var$getStatics(component) {
    // React v16.11 and below
    if ($cf60cbf4eccd6235$exports.isMemo(component)) return $460f8d0446813630$var$MEMO_STATICS;
     // React v16.12 and above
    return $460f8d0446813630$var$TYPE_STATICS[component['$$typeof']] || $460f8d0446813630$var$REACT_STATICS;
}
var $460f8d0446813630$var$defineProperty = Object.defineProperty;
var $460f8d0446813630$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $460f8d0446813630$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $460f8d0446813630$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $460f8d0446813630$var$getPrototypeOf = Object.getPrototypeOf;
var $460f8d0446813630$var$objectPrototype = Object.prototype;
function $460f8d0446813630$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($460f8d0446813630$var$objectPrototype) {
            var inheritedComponent = $460f8d0446813630$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $460f8d0446813630$var$objectPrototype) $460f8d0446813630$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $460f8d0446813630$var$getOwnPropertyNames(sourceComponent);
        if ($460f8d0446813630$var$getOwnPropertySymbols) keys = keys.concat($460f8d0446813630$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $460f8d0446813630$var$getStatics(targetComponent);
        var sourceStatics = $460f8d0446813630$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$460f8d0446813630$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $460f8d0446813630$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $460f8d0446813630$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$460f8d0446813630$exports = $460f8d0446813630$var$hoistNonReactStatics;






var $avTgU = parcelRequire("avTgU");

var $a4jUf = parcelRequire("a4jUf");


function $005263c7791cde3a$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}


// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $dbc52abb1c655422$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    "delete": function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache["delete"](key2);
    }
};
var $dbc52abb1c655422$export$2e2bcd8739ae039 = $dbc52abb1c655422$var$multiKeyStore;



var $avTgU = parcelRequire("avTgU");

var $avTgU = parcelRequire("avTgU");
var $75cbcca4f0a1891c$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createContext(null);
var $75cbcca4f0a1891c$export$2e2bcd8739ae039 = $75cbcca4f0a1891c$var$ThemeContext;


function $08dbfbd2a34dd470$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useContext((0, $75cbcca4f0a1891c$export$2e2bcd8739ae039));
    return theme;
}





var $avTgU = parcelRequire("avTgU");


var $ee6d210aea3c3a6a$var$hasSymbol = typeof Symbol === 'function' && Symbol["for"];
var $ee6d210aea3c3a6a$export$2e2bcd8739ae039 = $ee6d210aea3c3a6a$var$hasSymbol ? Symbol["for"]('mui.nested') : '__THEME_NESTED__';


/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $a5cd552b2a40781b$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $a5cd552b2a40781b$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($a5cd552b2a40781b$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $ee6d210aea3c3a6a$export$2e2bcd8739ae039] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}



var $a4jUf = parcelRequire("a4jUf");


var $a4jUf = parcelRequire("a4jUf");
var $4605ad320cc1db9b$var$now = Date.now();
var $4605ad320cc1db9b$var$fnValuesNs = "fnValues" + $4605ad320cc1db9b$var$now;
var $4605ad320cc1db9b$var$fnRuleNs = "fnStyle" + ++$4605ad320cc1db9b$var$now;
var $4605ad320cc1db9b$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $a4jUf.createRule)(name, {}, options);
            rule[$4605ad320cc1db9b$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($4605ad320cc1db9b$var$fnValuesNs in rule || $4605ad320cc1db9b$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$4605ad320cc1db9b$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$4605ad320cc1db9b$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$4605ad320cc1db9b$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $4605ad320cc1db9b$export$2e2bcd8739ae039 = $4605ad320cc1db9b$var$functionPlugin;


function $af4d8f9b3eb84c60$export$2e2bcd8739ae039() {
    $af4d8f9b3eb84c60$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af4d8f9b3eb84c60$export$2e2bcd8739ae039.apply(this, arguments);
}



var $a4jUf = parcelRequire("a4jUf");
var $04aae163641a6da3$var$at = '@global';
var $04aae163641a6da3$var$atPrefix = '@global ';
var $04aae163641a6da3$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $04aae163641a6da3$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $a4jUf.RuleList)((0, $af4d8f9b3eb84c60$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    };
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    };
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    };
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    };
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $04aae163641a6da3$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $04aae163641a6da3$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($04aae163641a6da3$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $af4d8f9b3eb84c60$export$2e2bcd8739ae039)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $04aae163641a6da3$var$separatorRegExp = /\s*,\s*/g;
function $04aae163641a6da3$var$addScope(selector, scope) {
    var parts = selector.split($04aae163641a6da3$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $04aae163641a6da3$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$04aae163641a6da3$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $af4d8f9b3eb84c60$export$2e2bcd8739ae039)({}, options, {
        selector: $04aae163641a6da3$var$addScope(name, rule.selector)
    }));
    delete style[$04aae163641a6da3$var$at];
}
function $04aae163641a6da3$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $04aae163641a6da3$var$at.length) !== $04aae163641a6da3$var$at) continue;
        var selector = $04aae163641a6da3$var$addScope(prop.substr($04aae163641a6da3$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $af4d8f9b3eb84c60$export$2e2bcd8739ae039)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $04aae163641a6da3$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $04aae163641a6da3$var$at) return new $04aae163641a6da3$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $04aae163641a6da3$var$atPrefix.length) === $04aae163641a6da3$var$atPrefix) return new $04aae163641a6da3$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $04aae163641a6da3$var$handleNestedGlobalContainerRule(rule, sheet);
        $04aae163641a6da3$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $04aae163641a6da3$export$2e2bcd8739ae039 = $04aae163641a6da3$var$jssGlobal;


function $44c2d5732ec79f4d$export$2e2bcd8739ae039() {
    $44c2d5732ec79f4d$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $44c2d5732ec79f4d$export$2e2bcd8739ae039.apply(this, arguments);
}



var $8a22b8135aa0a017$var$separatorRegExp = /\s*,\s*/g;
var $8a22b8135aa0a017$var$parentRegExp = /&/g;
var $8a22b8135aa0a017$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $8a22b8135aa0a017$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($8a22b8135aa0a017$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($8a22b8135aa0a017$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($8a22b8135aa0a017$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $44c2d5732ec79f4d$export$2e2bcd8739ae039)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $44c2d5732ec79f4d$export$2e2bcd8739ae039)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($8a22b8135aa0a017$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $44c2d5732ec79f4d$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $44c2d5732ec79f4d$export$2e2bcd8739ae039)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $8a22b8135aa0a017$export$2e2bcd8739ae039 = $8a22b8135aa0a017$var$jssNested;


/* eslint-disable no-var, prefer-template */ var $c7aca13ef4787713$var$uppercasePattern = /[A-Z]/g;
var $c7aca13ef4787713$var$msPattern = /^ms-/;
var $c7aca13ef4787713$var$cache = {};
function $c7aca13ef4787713$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $c7aca13ef4787713$var$hyphenateStyleName(name) {
    if ($c7aca13ef4787713$var$cache.hasOwnProperty(name)) return $c7aca13ef4787713$var$cache[name];
    var hName = name.replace($c7aca13ef4787713$var$uppercasePattern, $c7aca13ef4787713$var$toHyphenLower);
    return $c7aca13ef4787713$var$cache[name] = $c7aca13ef4787713$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $c7aca13ef4787713$export$2e2bcd8739ae039 = $c7aca13ef4787713$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $718dfa8c4749bd6d$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $c7aca13ef4787713$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($718dfa8c4749bd6d$var$convertCase);
        else converted.fallbacks = $718dfa8c4749bd6d$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $718dfa8c4749bd6d$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $718dfa8c4749bd6d$var$convertCase(style[index]);
            return style;
        }
        return $718dfa8c4749bd6d$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $c7aca13ef4787713$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $718dfa8c4749bd6d$export$2e2bcd8739ae039 = $718dfa8c4749bd6d$var$camelCase;



var $4aHdS = parcelRequire("4aHdS");

var $a4jUf = parcelRequire("a4jUf");
var $bcd660b67723aa63$var$px = (0, $a4jUf.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $bcd660b67723aa63$var$ms = (0, $a4jUf.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $bcd660b67723aa63$var$percent = (0, $a4jUf.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $bcd660b67723aa63$var$defaultUnits = {
    // Animation properties
    'animation-delay': $bcd660b67723aa63$var$ms,
    'animation-duration': $bcd660b67723aa63$var$ms,
    // Background properties
    'background-position': $bcd660b67723aa63$var$px,
    'background-position-x': $bcd660b67723aa63$var$px,
    'background-position-y': $bcd660b67723aa63$var$px,
    'background-size': $bcd660b67723aa63$var$px,
    // Border Properties
    border: $bcd660b67723aa63$var$px,
    'border-bottom': $bcd660b67723aa63$var$px,
    'border-bottom-left-radius': $bcd660b67723aa63$var$px,
    'border-bottom-right-radius': $bcd660b67723aa63$var$px,
    'border-bottom-width': $bcd660b67723aa63$var$px,
    'border-left': $bcd660b67723aa63$var$px,
    'border-left-width': $bcd660b67723aa63$var$px,
    'border-radius': $bcd660b67723aa63$var$px,
    'border-right': $bcd660b67723aa63$var$px,
    'border-right-width': $bcd660b67723aa63$var$px,
    'border-top': $bcd660b67723aa63$var$px,
    'border-top-left-radius': $bcd660b67723aa63$var$px,
    'border-top-right-radius': $bcd660b67723aa63$var$px,
    'border-top-width': $bcd660b67723aa63$var$px,
    'border-width': $bcd660b67723aa63$var$px,
    'border-block': $bcd660b67723aa63$var$px,
    'border-block-end': $bcd660b67723aa63$var$px,
    'border-block-end-width': $bcd660b67723aa63$var$px,
    'border-block-start': $bcd660b67723aa63$var$px,
    'border-block-start-width': $bcd660b67723aa63$var$px,
    'border-block-width': $bcd660b67723aa63$var$px,
    'border-inline': $bcd660b67723aa63$var$px,
    'border-inline-end': $bcd660b67723aa63$var$px,
    'border-inline-end-width': $bcd660b67723aa63$var$px,
    'border-inline-start': $bcd660b67723aa63$var$px,
    'border-inline-start-width': $bcd660b67723aa63$var$px,
    'border-inline-width': $bcd660b67723aa63$var$px,
    'border-start-start-radius': $bcd660b67723aa63$var$px,
    'border-start-end-radius': $bcd660b67723aa63$var$px,
    'border-end-start-radius': $bcd660b67723aa63$var$px,
    'border-end-end-radius': $bcd660b67723aa63$var$px,
    // Margin properties
    margin: $bcd660b67723aa63$var$px,
    'margin-bottom': $bcd660b67723aa63$var$px,
    'margin-left': $bcd660b67723aa63$var$px,
    'margin-right': $bcd660b67723aa63$var$px,
    'margin-top': $bcd660b67723aa63$var$px,
    'margin-block': $bcd660b67723aa63$var$px,
    'margin-block-end': $bcd660b67723aa63$var$px,
    'margin-block-start': $bcd660b67723aa63$var$px,
    'margin-inline': $bcd660b67723aa63$var$px,
    'margin-inline-end': $bcd660b67723aa63$var$px,
    'margin-inline-start': $bcd660b67723aa63$var$px,
    // Padding properties
    padding: $bcd660b67723aa63$var$px,
    'padding-bottom': $bcd660b67723aa63$var$px,
    'padding-left': $bcd660b67723aa63$var$px,
    'padding-right': $bcd660b67723aa63$var$px,
    'padding-top': $bcd660b67723aa63$var$px,
    'padding-block': $bcd660b67723aa63$var$px,
    'padding-block-end': $bcd660b67723aa63$var$px,
    'padding-block-start': $bcd660b67723aa63$var$px,
    'padding-inline': $bcd660b67723aa63$var$px,
    'padding-inline-end': $bcd660b67723aa63$var$px,
    'padding-inline-start': $bcd660b67723aa63$var$px,
    // Mask properties
    'mask-position-x': $bcd660b67723aa63$var$px,
    'mask-position-y': $bcd660b67723aa63$var$px,
    'mask-size': $bcd660b67723aa63$var$px,
    // Width and height properties
    height: $bcd660b67723aa63$var$px,
    width: $bcd660b67723aa63$var$px,
    'min-height': $bcd660b67723aa63$var$px,
    'max-height': $bcd660b67723aa63$var$px,
    'min-width': $bcd660b67723aa63$var$px,
    'max-width': $bcd660b67723aa63$var$px,
    // Position properties
    bottom: $bcd660b67723aa63$var$px,
    left: $bcd660b67723aa63$var$px,
    top: $bcd660b67723aa63$var$px,
    right: $bcd660b67723aa63$var$px,
    inset: $bcd660b67723aa63$var$px,
    'inset-block': $bcd660b67723aa63$var$px,
    'inset-block-end': $bcd660b67723aa63$var$px,
    'inset-block-start': $bcd660b67723aa63$var$px,
    'inset-inline': $bcd660b67723aa63$var$px,
    'inset-inline-end': $bcd660b67723aa63$var$px,
    'inset-inline-start': $bcd660b67723aa63$var$px,
    // Shadow properties
    'box-shadow': $bcd660b67723aa63$var$px,
    'text-shadow': $bcd660b67723aa63$var$px,
    // Column properties
    'column-gap': $bcd660b67723aa63$var$px,
    'column-rule': $bcd660b67723aa63$var$px,
    'column-rule-width': $bcd660b67723aa63$var$px,
    'column-width': $bcd660b67723aa63$var$px,
    // Font and text properties
    'font-size': $bcd660b67723aa63$var$px,
    'font-size-delta': $bcd660b67723aa63$var$px,
    'letter-spacing': $bcd660b67723aa63$var$px,
    'text-decoration-thickness': $bcd660b67723aa63$var$px,
    'text-indent': $bcd660b67723aa63$var$px,
    'text-stroke': $bcd660b67723aa63$var$px,
    'text-stroke-width': $bcd660b67723aa63$var$px,
    'word-spacing': $bcd660b67723aa63$var$px,
    // Motion properties
    motion: $bcd660b67723aa63$var$px,
    'motion-offset': $bcd660b67723aa63$var$px,
    // Outline properties
    outline: $bcd660b67723aa63$var$px,
    'outline-offset': $bcd660b67723aa63$var$px,
    'outline-width': $bcd660b67723aa63$var$px,
    // Perspective properties
    perspective: $bcd660b67723aa63$var$px,
    'perspective-origin-x': $bcd660b67723aa63$var$percent,
    'perspective-origin-y': $bcd660b67723aa63$var$percent,
    // Transform properties
    'transform-origin': $bcd660b67723aa63$var$percent,
    'transform-origin-x': $bcd660b67723aa63$var$percent,
    'transform-origin-y': $bcd660b67723aa63$var$percent,
    'transform-origin-z': $bcd660b67723aa63$var$percent,
    // Transition properties
    'transition-delay': $bcd660b67723aa63$var$ms,
    'transition-duration': $bcd660b67723aa63$var$ms,
    // Alignment properties
    'vertical-align': $bcd660b67723aa63$var$px,
    'flex-basis': $bcd660b67723aa63$var$px,
    // Some random properties
    'shape-margin': $bcd660b67723aa63$var$px,
    size: $bcd660b67723aa63$var$px,
    gap: $bcd660b67723aa63$var$px,
    // Grid properties
    grid: $bcd660b67723aa63$var$px,
    'grid-gap': $bcd660b67723aa63$var$px,
    'row-gap': $bcd660b67723aa63$var$px,
    'grid-row-gap': $bcd660b67723aa63$var$px,
    'grid-column-gap': $bcd660b67723aa63$var$px,
    'grid-template-rows': $bcd660b67723aa63$var$px,
    'grid-template-columns': $bcd660b67723aa63$var$px,
    'grid-auto-rows': $bcd660b67723aa63$var$px,
    'grid-auto-columns': $bcd660b67723aa63$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $bcd660b67723aa63$var$px,
    'box-shadow-y': $bcd660b67723aa63$var$px,
    'box-shadow-blur': $bcd660b67723aa63$var$px,
    'box-shadow-spread': $bcd660b67723aa63$var$px,
    'font-line-height': $bcd660b67723aa63$var$px,
    'text-shadow-x': $bcd660b67723aa63$var$px,
    'text-shadow-y': $bcd660b67723aa63$var$px,
    'text-shadow-blur': $bcd660b67723aa63$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $bcd660b67723aa63$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $bcd660b67723aa63$var$units = $bcd660b67723aa63$var$addCamelCasedVersion($bcd660b67723aa63$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $bcd660b67723aa63$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $bcd660b67723aa63$var$iterate(prop, value[i], options);
    else if ((typeof value === "undefined" ? "undefined" : (0, $4aHdS._)(value)) === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $bcd660b67723aa63$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $bcd660b67723aa63$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $bcd660b67723aa63$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $bcd660b67723aa63$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $bcd660b67723aa63$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $bcd660b67723aa63$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $bcd660b67723aa63$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $bcd660b67723aa63$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $bcd660b67723aa63$export$2e2bcd8739ae039 = $bcd660b67723aa63$var$defaultUnit;



var $1dEZ1 = parcelRequire("1dEZ1");
function $eb6a20d81fc3803b$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $d794e8a8a4275382$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $eb6a20d81fc3803b$export$2e2bcd8739ae039)(r);
}


function $e823e595eb61d0cc$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $3bb955151ee6de80$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $eb6a20d81fc3803b$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $eb6a20d81fc3803b$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $a5dc16ee1d926f31$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $6d12c5c3840df477$export$2e2bcd8739ae039(r) {
    return (0, $d794e8a8a4275382$export$2e2bcd8739ae039)(r) || (0, $e823e595eb61d0cc$export$2e2bcd8739ae039)(r) || (0, $3bb955151ee6de80$export$2e2bcd8739ae039)(r) || (0, $a5dc16ee1d926f31$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $763ddf5de31ec2a2$var$js = '';
var $763ddf5de31ec2a2$var$css = '';
var $763ddf5de31ec2a2$var$vendor = '';
var $763ddf5de31ec2a2$var$browser = '';
var $763ddf5de31ec2a2$var$isTouch = (0, $1dEZ1.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $1dEZ1.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $763ddf5de31ec2a2$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $763ddf5de31ec2a2$var$_document$createEleme = document.createElement('p'), $763ddf5de31ec2a2$var$style = $763ddf5de31ec2a2$var$_document$createEleme.style;
    var $763ddf5de31ec2a2$var$testProp = 'Transform';
    for(var $763ddf5de31ec2a2$var$key in $763ddf5de31ec2a2$var$jsCssMap)if ($763ddf5de31ec2a2$var$key + $763ddf5de31ec2a2$var$testProp in $763ddf5de31ec2a2$var$style) {
        $763ddf5de31ec2a2$var$js = $763ddf5de31ec2a2$var$key;
        $763ddf5de31ec2a2$var$css = $763ddf5de31ec2a2$var$jsCssMap[$763ddf5de31ec2a2$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($763ddf5de31ec2a2$var$js === 'Webkit' && 'msHyphens' in $763ddf5de31ec2a2$var$style) {
        $763ddf5de31ec2a2$var$js = 'ms';
        $763ddf5de31ec2a2$var$css = $763ddf5de31ec2a2$var$jsCssMap.ms;
        $763ddf5de31ec2a2$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($763ddf5de31ec2a2$var$js === 'Webkit' && '-apple-trailing-word' in $763ddf5de31ec2a2$var$style) $763ddf5de31ec2a2$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $763ddf5de31ec2a2$export$82e9f45cca5ba907 = {
    js: $763ddf5de31ec2a2$var$js,
    css: $763ddf5de31ec2a2$var$css,
    vendor: $763ddf5de31ec2a2$var$vendor,
    browser: $763ddf5de31ec2a2$var$browser,
    isTouch: $763ddf5de31ec2a2$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $763ddf5de31ec2a2$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $763ddf5de31ec2a2$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $763ddf5de31ec2a2$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'Webkit') return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $763ddf5de31ec2a2$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $763ddf5de31ec2a2$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $763ddf5de31ec2a2$var$camelize(str) {
    return str.replace($763ddf5de31ec2a2$var$regExp, $763ddf5de31ec2a2$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $763ddf5de31ec2a2$var$pascalize(str) {
    return $763ddf5de31ec2a2$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $763ddf5de31ec2a2$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($763ddf5de31ec2a2$var$camelize(longhand) in style) return prop;
            if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js + $763ddf5de31ec2a2$var$pascalize(longhand) in style) return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $763ddf5de31ec2a2$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.vendor === 'apple' && !$763ddf5de31ec2a2$export$82e9f45cca5ba907.isTouch) return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $763ddf5de31ec2a2$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $763ddf5de31ec2a2$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $763ddf5de31ec2a2$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'Webkit' || $763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'ms' && $763ddf5de31ec2a2$export$82e9f45cca5ba907.browser !== 'edge') return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $763ddf5de31ec2a2$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'Moz' || $763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'ms' || $763ddf5de31ec2a2$export$82e9f45cca5ba907.vendor === 'apple') return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $763ddf5de31ec2a2$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $763ddf5de31ec2a2$var$pascalize(prop);
            return jsProp in style ? $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $763ddf5de31ec2a2$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $763ddf5de31ec2a2$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $763ddf5de31ec2a2$export$82e9f45cca5ba907.js + $763ddf5de31ec2a2$var$pascalize(newProp) in style ? $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $763ddf5de31ec2a2$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $763ddf5de31ec2a2$var$camelize(prop) in style ? prop : false;
    }
};
var $763ddf5de31ec2a2$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $763ddf5de31ec2a2$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js + pascalized in style) return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $763ddf5de31ec2a2$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'ms') return "" + $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $763ddf5de31ec2a2$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($763ddf5de31ec2a2$export$82e9f45cca5ba907.js === 'ms') return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $763ddf5de31ec2a2$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $763ddf5de31ec2a2$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $763ddf5de31ec2a2$var$propMap[prop];
        if (!newProp) return false;
        return $763ddf5de31ec2a2$export$82e9f45cca5ba907.js + $763ddf5de31ec2a2$var$pascalize(newProp) in style ? $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $763ddf5de31ec2a2$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $763ddf5de31ec2a2$var$propKeys = Object.keys($763ddf5de31ec2a2$var$propMap$1);
var $763ddf5de31ec2a2$var$prefixCss = function prefixCss(p) {
    return $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $763ddf5de31ec2a2$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($763ddf5de31ec2a2$var$propKeys.indexOf(prop) > -1) {
            var newProp = $763ddf5de31ec2a2$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $763ddf5de31ec2a2$export$82e9f45cca5ba907.js + $763ddf5de31ec2a2$var$pascalize(newProp) in style ? $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($763ddf5de31ec2a2$export$82e9f45cca5ba907.js + $763ddf5de31ec2a2$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($763ddf5de31ec2a2$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $763ddf5de31ec2a2$var$plugins = [
    $763ddf5de31ec2a2$var$appearence,
    $763ddf5de31ec2a2$var$colorAdjust,
    $763ddf5de31ec2a2$var$mask,
    $763ddf5de31ec2a2$var$textOrientation,
    $763ddf5de31ec2a2$var$transform,
    $763ddf5de31ec2a2$var$transition,
    $763ddf5de31ec2a2$var$writingMode,
    $763ddf5de31ec2a2$var$userSelect,
    $763ddf5de31ec2a2$var$breakPropsOld,
    $763ddf5de31ec2a2$var$inlineLogicalOld,
    $763ddf5de31ec2a2$var$unprefixed,
    $763ddf5de31ec2a2$var$prefixed,
    $763ddf5de31ec2a2$var$scrollSnap,
    $763ddf5de31ec2a2$var$overscrollBehavior,
    $763ddf5de31ec2a2$var$flex2012,
    $763ddf5de31ec2a2$var$flex2009
];
var $763ddf5de31ec2a2$var$propertyDetectors = $763ddf5de31ec2a2$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $763ddf5de31ec2a2$var$noPrefill = $763ddf5de31ec2a2$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $6d12c5c3840df477$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $763ddf5de31ec2a2$var$el;
var $763ddf5de31ec2a2$var$cache = {};
if (0, $1dEZ1.default) {
    $763ddf5de31ec2a2$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $763ddf5de31ec2a2$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $763ddf5de31ec2a2$var$key$1 in $763ddf5de31ec2a2$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($763ddf5de31ec2a2$var$key$1)) $763ddf5de31ec2a2$var$cache[$763ddf5de31ec2a2$var$computed[$763ddf5de31ec2a2$var$key$1]] = $763ddf5de31ec2a2$var$computed[$763ddf5de31ec2a2$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $763ddf5de31ec2a2$var$noPrefill.forEach(function(x) {
        return delete $763ddf5de31ec2a2$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $763ddf5de31ec2a2$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$763ddf5de31ec2a2$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($763ddf5de31ec2a2$var$cache[prop] != null) return $763ddf5de31ec2a2$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $763ddf5de31ec2a2$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $763ddf5de31ec2a2$var$propertyDetectors.length; i++){
        $763ddf5de31ec2a2$var$cache[prop] = $763ddf5de31ec2a2$var$propertyDetectors[i](prop, $763ddf5de31ec2a2$var$el.style, options); // Break loop, if value found.
        if ($763ddf5de31ec2a2$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $763ddf5de31ec2a2$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $763ddf5de31ec2a2$var$cache[prop];
}
var $763ddf5de31ec2a2$var$cache$1 = {};
var $763ddf5de31ec2a2$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $763ddf5de31ec2a2$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $763ddf5de31ec2a2$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $763ddf5de31ec2a2$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $763ddf5de31ec2a2$export$ce097f82c2e4551a(p1) : ", " + $763ddf5de31ec2a2$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $1dEZ1.default) $763ddf5de31ec2a2$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $763ddf5de31ec2a2$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$763ddf5de31ec2a2$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($763ddf5de31ec2a2$var$cache$1[cacheKey] != null) return $763ddf5de31ec2a2$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $763ddf5de31ec2a2$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $763ddf5de31ec2a2$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($763ddf5de31ec2a2$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($763ddf5de31ec2a2$var$transPropsRegExp, $763ddf5de31ec2a2$var$prefixTransitionCallback);
    else if ($763ddf5de31ec2a2$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $763ddf5de31ec2a2$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $763ddf5de31ec2a2$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $763ddf5de31ec2a2$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($763ddf5de31ec2a2$var$el$1.style[property] === '') {
            $763ddf5de31ec2a2$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $763ddf5de31ec2a2$var$el$1.style[property] = ''; // Write current value to cache.
    $763ddf5de31ec2a2$var$cache$1[cacheKey] = prefixedValue;
    return $763ddf5de31ec2a2$var$cache$1[cacheKey];
}



var $a4jUf = parcelRequire("a4jUf");
/**
 * Add vendor prefix to a property name when needed.
 */ function $cdd2bc4576f18e8c$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $763ddf5de31ec2a2$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $763ddf5de31ec2a2$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $763ddf5de31ec2a2$export$511766124059c277)(supportedProp, (0, $a4jUf.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $763ddf5de31ec2a2$export$511766124059c277)(prop, (0, $a4jUf.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $cdd2bc4576f18e8c$export$2e2bcd8739ae039 = $cdd2bc4576f18e8c$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $662a16ae654a5be4$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $662a16ae654a5be4$export$2e2bcd8739ae039 = $662a16ae654a5be4$var$jssPropsSort;


function $11b4054dd6e01213$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $4605ad320cc1db9b$export$2e2bcd8739ae039)(),
            (0, $04aae163641a6da3$export$2e2bcd8739ae039)(),
            (0, $8a22b8135aa0a017$export$2e2bcd8739ae039)(),
            (0, $718dfa8c4749bd6d$export$2e2bcd8739ae039)(),
            (0, $bcd660b67723aa63$export$2e2bcd8739ae039)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $cdd2bc4576f18e8c$export$2e2bcd8739ae039)(),
            (0, $662a16ae654a5be4$export$2e2bcd8739ae039)()
        ]
    };
}


var $e888256296bdb570$var$jss = (0, $a4jUf.create)((0, $11b4054dd6e01213$export$2e2bcd8739ae039)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $e888256296bdb570$var$generateClassName = (0, $a5cd552b2a40781b$export$2e2bcd8739ae039)(); // Exported for test purposes
var $e888256296bdb570$export$70a8aea9ff58d1cd = new Map();
var $e888256296bdb570$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $e888256296bdb570$var$generateClassName,
    jss: $e888256296bdb570$var$jss,
    sheetsCache: null,
    sheetsManager: $e888256296bdb570$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $e888256296bdb570$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createContext($e888256296bdb570$var$defaultOptions);
var $e888256296bdb570$var$injectFirstNode;
function $e888256296bdb570$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $859833b6c80a41a3$export$2e2bcd8739ae039)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useContext($e888256296bdb570$export$f4de434b269fe487);
    var context = (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$e888256296bdb570$var$injectFirstNode) {
            var head = document.head;
            $e888256296bdb570$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($e888256296bdb570$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $a4jUf.create)({
            plugins: (0, $11b4054dd6e01213$export$2e2bcd8739ae039)().plugins,
            insertionPoint: $e888256296bdb570$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createElement($e888256296bdb570$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}


/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $5c760871f4543d67$var$indexCounter = -1000000000;
function $5c760871f4543d67$export$a2647aa13413c947() {
    $5c760871f4543d67$var$indexCounter += 1;
    return $5c760871f4543d67$var$indexCounter;
}



function $ab70d9ad1d6386e5$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ab70d9ad1d6386e5$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ab70d9ad1d6386e5$export$2e2bcd8739ae039(o);
}


function $0cbdff2ffd017aac$export$2e2bcd8739ae039() {
    return $0cbdff2ffd017aac$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0cbdff2ffd017aac$export$2e2bcd8739ae039.apply(null, arguments);
}


function $fee410fc350db67a$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $fee410fc350db67a$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fee410fc350db67a$export$2e2bcd8739ae039(o);
}


function $6e338978978d5da0$export$53b83ca8eaab0383(item) {
    return item && (0, $fee410fc350db67a$export$2e2bcd8739ae039)(item) === 'object' && item.constructor === Object;
}
function $6e338978978d5da0$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $0cbdff2ffd017aac$export$2e2bcd8739ae039)({}, target) : target;
    if ($6e338978978d5da0$export$53b83ca8eaab0383(target) && $6e338978978d5da0$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($6e338978978d5da0$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $6e338978978d5da0$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}



function $9238fd515e434ee7$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $6e338978978d5da0$export$2e2bcd8739ae039)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}


// We use the same empty object to ref count the styles that don't need a theme object.
var $89fa2ea9f6f9c831$var$noopTheme = {};
var $89fa2ea9f6f9c831$export$2e2bcd8739ae039 = $89fa2ea9f6f9c831$var$noopTheme;


function $ae4b3ead62b6ea82$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $005263c7791cde3a$export$2e2bcd8739ae039)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $ae4b3ead62b6ea82$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $dbc52abb1c655422$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $dbc52abb1c655422$export$2e2bcd8739ae039).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $dbc52abb1c655422$export$2e2bcd8739ae039).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $dbc52abb1c655422$export$2e2bcd8739ae039).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $a4jUf.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $005263c7791cde3a$export$2e2bcd8739ae039)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $ae4b3ead62b6ea82$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $ae4b3ead62b6ea82$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $dbc52abb1c655422$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $dbc52abb1c655422$export$2e2bcd8739ae039)["delete"](stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $ae4b3ead62b6ea82$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $ae4b3ead62b6ea82$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $89fa2ea9f6f9c831$export$2e2bcd8739ae039) : _options$defaultTheme, stylesOptions2 = (0, $859833b6c80a41a3$export$2e2bcd8739ae039)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $9238fd515e434ee7$export$2e2bcd8739ae039)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $5c760871f4543d67$export$a2647aa13413c947)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $08dbfbd2a34dd470$export$2e2bcd8739ae039)() || defaultTheme;
        var stylesOptions = (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({}, (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useContext((0, $e888256296bdb570$export$f4de434b269fe487)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useRef();
        $ae4b3ead62b6ea82$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $ae4b3ead62b6ea82$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $ae4b3ead62b6ea82$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useEffect(function() {
            if (shouldUpdate.current) $ae4b3ead62b6ea82$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $ae4b3ead62b6ea82$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}


/* eslint-disable no-restricted-syntax */ function $4c8915f574ad4003$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}



// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $d60d0cee51468d43$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $859833b6c80a41a3$export$2e2bcd8739ae039)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $ae4b3ead62b6ea82$export$2e2bcd8739ae039)(stylesOrCreator, (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $859833b6c80a41a3$export$2e2bcd8739ae039)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $08dbfbd2a34dd470$export$2e2bcd8739ae039)() || defaultTheme;
                if (name) more = (0, $4c8915f574ad4003$export$2e2bcd8739ae039)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createElement(Component, (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($460f8d0446813630$exports)))(WithStyles, Component);
        return WithStyles;
    };
};
var $d60d0cee51468d43$export$2e2bcd8739ae039 = $d60d0cee51468d43$var$withStyles;


function $637f6152604cc8c2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $637f6152604cc8c2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $637f6152604cc8c2$export$2e2bcd8739ae039(o);
}



function $f49c6deb905c071e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $637f6152604cc8c2$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $637f6152604cc8c2$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $44f0e0a21bbebdf8$export$2e2bcd8739ae039(t) {
    var i = (0, $f49c6deb905c071e$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $637f6152604cc8c2$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $91fecad27ff9c4b4$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $44f0e0a21bbebdf8$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}






var $186289fdf62a36db$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $186289fdf62a36db$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $186289fdf62a36db$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$186289fdf62a36db$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $186289fdf62a36db$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $186289fdf62a36db$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $186289fdf62a36db$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$186289fdf62a36db$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$186289fdf62a36db$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        keys: $186289fdf62a36db$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}




function $8c5ac1a7cacd0e89$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $91fecad27ff9c4b4$export$2e2bcd8739ae039)({}, breakpoints.up('sm'), (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $91fecad27ff9c4b4$export$2e2bcd8739ae039)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $91fecad27ff9c4b4$export$2e2bcd8739ae039)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}




/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $251b2509b429bc46$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = 'https://mui.com/production-error/?code=' + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }


var $30dd3d75685a94ad$var$common = {
    black: '#000',
    white: '#fff'
};
var $30dd3d75685a94ad$export$2e2bcd8739ae039 = $30dd3d75685a94ad$var$common;


var $57fd14f6526ba667$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $57fd14f6526ba667$export$2e2bcd8739ae039 = $57fd14f6526ba667$var$grey;


var $19c117622f6f8d59$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $19c117622f6f8d59$export$2e2bcd8739ae039 = $19c117622f6f8d59$var$indigo;


var $ada253627c3482ae$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $ada253627c3482ae$export$2e2bcd8739ae039 = $ada253627c3482ae$var$pink;


var $8ecd1c893ebcda83$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $8ecd1c893ebcda83$export$2e2bcd8739ae039 = $8ecd1c893ebcda83$var$red;


var $3e873d2266aca27f$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $3e873d2266aca27f$export$2e2bcd8739ae039 = $3e873d2266aca27f$var$orange;


var $d1b9652e1d2f6851$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $d1b9652e1d2f6851$export$2e2bcd8739ae039 = $d1b9652e1d2f6851$var$blue;


var $4d85f54a794aa0b1$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $4d85f54a794aa0b1$export$2e2bcd8739ae039 = $4d85f54a794aa0b1$var$green;



/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $53c8c435ad2b1764$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $53c8c435ad2b1764$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $53c8c435ad2b1764$var$intToHex(_int) {
    var hex = _int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $53c8c435ad2b1764$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $53c8c435ad2b1764$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $53c8c435ad2b1764$var$intToHex(n);
    }).join(''));
}
function $53c8c435ad2b1764$export$29fb7152bd3f781a(color) {
    color = $53c8c435ad2b1764$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $53c8c435ad2b1764$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $53c8c435ad2b1764$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $53c8c435ad2b1764$export$677b39864803984e($53c8c435ad2b1764$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $251b2509b429bc46$export$2e2bcd8739ae039)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $53c8c435ad2b1764$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $53c8c435ad2b1764$export$d061e26956a60b0a(foreground, background) {
    var lumA = $53c8c435ad2b1764$export$c852d90bf7403b62(foreground);
    var lumB = $53c8c435ad2b1764$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $53c8c435ad2b1764$export$c852d90bf7403b62(color) {
    color = $53c8c435ad2b1764$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $53c8c435ad2b1764$export$677b39864803984e($53c8c435ad2b1764$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $53c8c435ad2b1764$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $53c8c435ad2b1764$export$c852d90bf7403b62(color) > 0.5 ? $53c8c435ad2b1764$export$4b073707ff63303(color, coefficient) : $53c8c435ad2b1764$export$c0816ed86df316af(color, coefficient);
}
var $53c8c435ad2b1764$var$warnedOnce = false;
function $53c8c435ad2b1764$export$cbea29d068a2e18f(color, value) {
    return $53c8c435ad2b1764$export$58f0f39f63f3cf42(color, value);
}
function $53c8c435ad2b1764$export$58f0f39f63f3cf42(color, value) {
    color = $53c8c435ad2b1764$export$677b39864803984e(color);
    value = $53c8c435ad2b1764$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $53c8c435ad2b1764$export$211a73f2b8c10ce4(color);
}
function $53c8c435ad2b1764$export$4b073707ff63303(color, coefficient) {
    color = $53c8c435ad2b1764$export$677b39864803984e(color);
    coefficient = $53c8c435ad2b1764$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $53c8c435ad2b1764$export$211a73f2b8c10ce4(color);
}
function $53c8c435ad2b1764$export$c0816ed86df316af(color, coefficient) {
    color = $53c8c435ad2b1764$export$677b39864803984e(color);
    coefficient = $53c8c435ad2b1764$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $53c8c435ad2b1764$export$211a73f2b8c10ce4(color);
}


var $f0f57ae28f6ba505$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $30dd3d75685a94ad$export$2e2bcd8739ae039).white,
        "default": (0, $57fd14f6526ba667$export$2e2bcd8739ae039)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $f0f57ae28f6ba505$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $30dd3d75685a94ad$export$2e2bcd8739ae039).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $57fd14f6526ba667$export$2e2bcd8739ae039)[800],
        "default": '#303030'
    },
    action: {
        active: (0, $30dd3d75685a94ad$export$2e2bcd8739ae039).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $f0f57ae28f6ba505$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $53c8c435ad2b1764$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $53c8c435ad2b1764$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $f0f57ae28f6ba505$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $19c117622f6f8d59$export$2e2bcd8739ae039)[300],
        main: (0, $19c117622f6f8d59$export$2e2bcd8739ae039)[500],
        dark: (0, $19c117622f6f8d59$export$2e2bcd8739ae039)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $ada253627c3482ae$export$2e2bcd8739ae039).A200,
        main: (0, $ada253627c3482ae$export$2e2bcd8739ae039).A400,
        dark: (0, $ada253627c3482ae$export$2e2bcd8739ae039).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $8ecd1c893ebcda83$export$2e2bcd8739ae039)[300],
        main: (0, $8ecd1c893ebcda83$export$2e2bcd8739ae039)[500],
        dark: (0, $8ecd1c893ebcda83$export$2e2bcd8739ae039)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $3e873d2266aca27f$export$2e2bcd8739ae039)[300],
        main: (0, $3e873d2266aca27f$export$2e2bcd8739ae039)[500],
        dark: (0, $3e873d2266aca27f$export$2e2bcd8739ae039)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $d1b9652e1d2f6851$export$2e2bcd8739ae039)[300],
        main: (0, $d1b9652e1d2f6851$export$2e2bcd8739ae039)[500],
        dark: (0, $d1b9652e1d2f6851$export$2e2bcd8739ae039)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $4d85f54a794aa0b1$export$2e2bcd8739ae039)[300],
        main: (0, $4d85f54a794aa0b1$export$2e2bcd8739ae039)[500],
        dark: (0, $4d85f54a794aa0b1$export$2e2bcd8739ae039)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $53c8c435ad2b1764$export$d061e26956a60b0a)(background, $f0f57ae28f6ba505$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $f0f57ae28f6ba505$export$55ce6f3a06c59543.text.primary : $f0f57ae28f6ba505$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $251b2509b429bc46$export$2e2bcd8739ae039)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $251b2509b429bc46$export$2e2bcd8739ae039)(5, JSON.stringify(color.main)));
        $f0f57ae28f6ba505$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $f0f57ae28f6ba505$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $f0f57ae28f6ba505$export$55ce6f3a06c59543,
        light: $f0f57ae28f6ba505$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $6e338978978d5da0$export$2e2bcd8739ae039)((0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: (0, $30dd3d75685a94ad$export$2e2bcd8739ae039),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $57fd14f6526ba667$export$2e2bcd8739ae039),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}





function $57cbb6fc637b611a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $57cbb6fc637b611a$var$warnedOnce = false;
function $57cbb6fc637b611a$var$roundWithDeprecationWarning(value) {
    return $57cbb6fc637b611a$var$round(value);
}
var $57cbb6fc637b611a$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $57cbb6fc637b611a$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $57cbb6fc637b611a$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $57cbb6fc637b611a$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $57cbb6fc637b611a$var$defaultFontFamily ? {
            letterSpacing: "".concat($57cbb6fc637b611a$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $57cbb6fc637b611a$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $57cbb6fc637b611a$var$caseAllCaps)
    };
    return (0, $6e338978978d5da0$export$2e2bcd8739ae039)((0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $57cbb6fc637b611a$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


var $b6258eb3b9fbd6f3$var$shadowKeyUmbraOpacity = 0.2;
var $b6258eb3b9fbd6f3$var$shadowKeyPenumbraOpacity = 0.14;
var $b6258eb3b9fbd6f3$var$shadowAmbientShadowOpacity = 0.12;
function $b6258eb3b9fbd6f3$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($b6258eb3b9fbd6f3$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($b6258eb3b9fbd6f3$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($b6258eb3b9fbd6f3$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $b6258eb3b9fbd6f3$var$shadows = [
    'none',
    $b6258eb3b9fbd6f3$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $b6258eb3b9fbd6f3$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $b6258eb3b9fbd6f3$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $b6258eb3b9fbd6f3$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $b6258eb3b9fbd6f3$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $b6258eb3b9fbd6f3$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $b6258eb3b9fbd6f3$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $b6258eb3b9fbd6f3$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $b6258eb3b9fbd6f3$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $b6258eb3b9fbd6f3$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $b6258eb3b9fbd6f3$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $b6258eb3b9fbd6f3$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $b6258eb3b9fbd6f3$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $b6258eb3b9fbd6f3$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $b6258eb3b9fbd6f3$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $b6258eb3b9fbd6f3$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $b6258eb3b9fbd6f3$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $b6258eb3b9fbd6f3$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $b6258eb3b9fbd6f3$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $b6258eb3b9fbd6f3$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $b6258eb3b9fbd6f3$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $b6258eb3b9fbd6f3$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $b6258eb3b9fbd6f3$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $b6258eb3b9fbd6f3$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $b6258eb3b9fbd6f3$export$2e2bcd8739ae039 = $b6258eb3b9fbd6f3$var$shadows;


var $0bb5ee8b8b9e0b09$var$shape = {
    borderRadius: 4
};
var $0bb5ee8b8b9e0b09$export$2e2bcd8739ae039 = $0bb5ee8b8b9e0b09$var$shape;


function $b9402858219f59b9$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $85a5870e85700279$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $9eb9754873709b69$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $45e9aa1dc71b2598$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9eb9754873709b69$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9eb9754873709b69$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $4ab9797d0a64c6bc$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $06c130e2d6e7e437$export$2e2bcd8739ae039(r, e) {
    return (0, $b9402858219f59b9$export$2e2bcd8739ae039)(r) || (0, $85a5870e85700279$export$2e2bcd8739ae039)(r, e) || (0, $45e9aa1dc71b2598$export$2e2bcd8739ae039)(r, e) || (0, $4ab9797d0a64c6bc$export$2e2bcd8739ae039)();
}




function $1f34f3da5f3e3ed2$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $9eb9754873709b69$export$2e2bcd8739ae039)(r);
}


function $efb4a687dc24d7f5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $fd47321db8c7ebfa$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $fd420871a090db67$export$2e2bcd8739ae039(r) {
    return (0, $1f34f3da5f3e3ed2$export$2e2bcd8739ae039)(r) || (0, $efb4a687dc24d7f5$export$2e2bcd8739ae039)(r) || (0, $45e9aa1dc71b2598$export$2e2bcd8739ae039)(r) || (0, $fd47321db8c7ebfa$export$2e2bcd8739ae039)();
}


function $57cbc22858237e27$export$2e2bcd8739ae039() {
    return $57cbc22858237e27$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $57cbc22858237e27$export$2e2bcd8739ae039.apply(null, arguments);
}


function $17f4498c52811722$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $17f4498c52811722$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $17f4498c52811722$export$2e2bcd8739ae039(o);
}




function $eac44ce46ea26716$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $6e338978978d5da0$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $eac44ce46ea26716$export$2e2bcd8739ae039 = $eac44ce46ea26716$var$merge;


// For instance with the first breakpoint xs: [xs, sm[.
var $6a34ed1b259ccf73$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $6a34ed1b259ccf73$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($6a34ed1b259ccf73$var$values[key], "px)");
    }
};
function $6a34ed1b259ccf73$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $6a34ed1b259ccf73$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $17f4498c52811722$export$2e2bcd8739ae039)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $6a34ed1b259ccf73$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $6a34ed1b259ccf73$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $6a34ed1b259ccf73$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $57cbc22858237e27$export$2e2bcd8739ae039)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $eac44ce46ea26716$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $fd420871a090db67$export$2e2bcd8739ae039)(styleFunction.filterProps));
    return newStyleFunction;
}
var $6a34ed1b259ccf73$export$2e2bcd8739ae039 = $6a34ed1b259ccf73$var$breakpoints;



function $eea51527435e58af$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $eef3a64a1e83673f$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $eef3a64a1e83673f$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $eef3a64a1e83673f$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $eef3a64a1e83673f$var$getCssProperties = (0, $eea51527435e58af$export$2e2bcd8739ae039)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($eef3a64a1e83673f$var$aliases[prop]) prop = $eef3a64a1e83673f$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $06c130e2d6e7e437$export$2e2bcd8739ae039)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $eef3a64a1e83673f$var$properties[a];
    var direction = $eef3a64a1e83673f$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $eef3a64a1e83673f$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $eef3a64a1e83673f$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return function() {
        return undefined;
    };
}
function $eef3a64a1e83673f$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $eef3a64a1e83673f$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $eef3a64a1e83673f$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $eef3a64a1e83673f$var$spacing(props) {
    var theme = props.theme;
    var transformer = $eef3a64a1e83673f$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($eef3a64a1e83673f$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $eef3a64a1e83673f$var$getCssProperties(prop);
        var styleFromPropValue = $eef3a64a1e83673f$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $6a34ed1b259ccf73$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    }).reduce((0, $eac44ce46ea26716$export$2e2bcd8739ae039), {});
}
$eef3a64a1e83673f$var$spacing.propTypes = {};
$eef3a64a1e83673f$var$spacing.filterProps = $eef3a64a1e83673f$var$spacingKeys;
var $eef3a64a1e83673f$export$2e2bcd8739ae039 = $eef3a64a1e83673f$var$spacing;


var $1a84f1fc7b9d433a$var$warnOnce;
function $1a84f1fc7b9d433a$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $eef3a64a1e83673f$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}



var $44965355d4581554$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $44965355d4581554$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $44965355d4581554$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $44965355d4581554$export$2e2bcd8739ae039 = {
    easing: $44965355d4581554$export$24c5ac7c37452e7d,
    duration: $44965355d4581554$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $44965355d4581554$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $44965355d4581554$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $44965355d4581554$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $44965355d4581554$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $2fbace80f170c823$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $2fbace80f170c823$export$2e2bcd8739ae039 = $2fbace80f170c823$var$zIndex;


function $f5d42ee048d59524$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $f0f57ae28f6ba505$export$2e2bcd8739ae039)(paletteInput);
    var breakpoints = (0, $186289fdf62a36db$export$2e2bcd8739ae039)(breakpointsInput);
    var spacing = (0, $1a84f1fc7b9d433a$export$2e2bcd8739ae039)(spacingInput);
    var muiTheme = (0, $6e338978978d5da0$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $8c5ac1a7cacd0e89$export$2e2bcd8739ae039)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $b6258eb3b9fbd6f3$export$2e2bcd8739ae039),
        typography: (0, $57cbb6fc637b611a$export$2e2bcd8739ae039)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $0bb5ee8b8b9e0b09$export$2e2bcd8739ae039),
        transitions: (0, $44965355d4581554$export$2e2bcd8739ae039),
        zIndex: (0, $2fbace80f170c823$export$2e2bcd8739ae039)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $6e338978978d5da0$export$2e2bcd8739ae039)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $f5d42ee048d59524$var$warnedOnce = false;
function $f5d42ee048d59524$export$c469355549431d9b() {
    return $f5d42ee048d59524$var$createTheme.apply(void 0, arguments);
}
var $f5d42ee048d59524$export$2e2bcd8739ae039 = $f5d42ee048d59524$var$createTheme;


var $71c38126c6fca4d8$var$defaultTheme = (0, $f5d42ee048d59524$export$2e2bcd8739ae039)();
var $71c38126c6fca4d8$export$2e2bcd8739ae039 = $71c38126c6fca4d8$var$defaultTheme;


function $1431f684f949e5cb$var$withStyles(stylesOrCreator, options) {
    return (0, $d60d0cee51468d43$export$2e2bcd8739ae039)(stylesOrCreator, (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        defaultTheme: (0, $71c38126c6fca4d8$export$2e2bcd8739ae039)
    }, options));
}
var $1431f684f949e5cb$export$2e2bcd8739ae039 = $1431f684f949e5cb$var$withStyles;






var $avTgU = parcelRequire("avTgU");

var $b4e3bc3b27e4fc4b$exports = {};
'use strict';
function $b4e3bc3b27e4fc4b$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4e3bc3b27e4fc4b$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4e3bc3b27e4fc4b$var$checkDCE();

$b4e3bc3b27e4fc4b$exports = (parcelRequire("c90Mh"));





var $avTgU = parcelRequire("avTgU");
// TODO v5: consider to make it private
function $d4b00d146347a562$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


function $51a416293b736e3c$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $avTgU.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $d4b00d146347a562$export$2e2bcd8739ae039)(refA, refValue);
            (0, $d4b00d146347a562$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $avTgU = parcelRequire("avTgU");
var $ba1853cec4ff049d$var$useEnhancedEffect = typeof window !== 'undefined' ? $avTgU.useLayoutEffect : $avTgU.useEffect;
function $ba1853cec4ff049d$export$2e2bcd8739ae039(fn) {
    var ref = $avTgU.useRef(fn);
    $ba1853cec4ff049d$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $avTgU.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $avTgU = parcelRequire("avTgU");

var $8a3cf8c663a4fdf5$var$hadKeyboardEvent = true;
var $8a3cf8c663a4fdf5$var$hadFocusVisibleRecently = false;
var $8a3cf8c663a4fdf5$var$hadFocusVisibleRecentlyTimeout = null;
var $8a3cf8c663a4fdf5$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $8a3cf8c663a4fdf5$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === 'INPUT' && $8a3cf8c663a4fdf5$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $8a3cf8c663a4fdf5$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $8a3cf8c663a4fdf5$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $8a3cf8c663a4fdf5$var$handlePointerDown() {
    $8a3cf8c663a4fdf5$var$hadKeyboardEvent = false;
}
function $8a3cf8c663a4fdf5$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($8a3cf8c663a4fdf5$var$hadFocusVisibleRecently) $8a3cf8c663a4fdf5$var$hadKeyboardEvent = true;
    }
}
function $8a3cf8c663a4fdf5$var$prepare(doc) {
    doc.addEventListener('keydown', $8a3cf8c663a4fdf5$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $8a3cf8c663a4fdf5$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $8a3cf8c663a4fdf5$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $8a3cf8c663a4fdf5$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $8a3cf8c663a4fdf5$var$handleVisibilityChange, true);
}
function $8a3cf8c663a4fdf5$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $8a3cf8c663a4fdf5$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $8a3cf8c663a4fdf5$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $8a3cf8c663a4fdf5$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $8a3cf8c663a4fdf5$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $8a3cf8c663a4fdf5$var$handleVisibilityChange, true);
}
function $8a3cf8c663a4fdf5$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $8a3cf8c663a4fdf5$var$hadKeyboardEvent || $8a3cf8c663a4fdf5$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $8a3cf8c663a4fdf5$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $8a3cf8c663a4fdf5$var$hadFocusVisibleRecently = true;
    window.clearTimeout($8a3cf8c663a4fdf5$var$hadFocusVisibleRecentlyTimeout);
    $8a3cf8c663a4fdf5$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $8a3cf8c663a4fdf5$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $8a3cf8c663a4fdf5$export$2e2bcd8739ae039() {
    var ref = $avTgU.useCallback(function(instance) {
        var node = $b4e3bc3b27e4fc4b$exports.findDOMNode(instance);
        if (node != null) $8a3cf8c663a4fdf5$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $8a3cf8c663a4fdf5$var$isFocusVisible,
        onBlurVisible: $8a3cf8c663a4fdf5$var$handleBlurVisible,
        ref: ref
    };
}



function $318b71bb385198a0$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $0fbd0762fc66acba$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $318b71bb385198a0$export$2e2bcd8739ae039)(r);
}


function $89b8e61f8ac84e57$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $a41cd76cdb05f258$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $318b71bb385198a0$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $318b71bb385198a0$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $9432f88ad7955bc4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $2f46c3e0b8783927$export$2e2bcd8739ae039(r) {
    return (0, $0fbd0762fc66acba$export$2e2bcd8739ae039)(r) || (0, $89b8e61f8ac84e57$export$2e2bcd8739ae039)(r) || (0, $a41cd76cdb05f258$export$2e2bcd8739ae039)(r) || (0, $9432f88ad7955bc4$export$2e2bcd8739ae039)();
}




var $avTgU = parcelRequire("avTgU");

function $ee247bcca180bf14$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $d09d16700cb2a0b8$export$2e2bcd8739ae039() {
    $d09d16700cb2a0b8$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d09d16700cb2a0b8$export$2e2bcd8739ae039.apply(this, arguments);
}


function $c1ba359986f6d8c1$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $0c210ac3b9b6f56a$export$2e2bcd8739ae039(o, p) {
    $0c210ac3b9b6f56a$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0c210ac3b9b6f56a$export$2e2bcd8739ae039(o, p);
}


function $01f44fff890f6869$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $0c210ac3b9b6f56a$export$2e2bcd8739ae039)(subClass, superClass);
}




var $avTgU = parcelRequire("avTgU");

var $avTgU = parcelRequire("avTgU");
var $dfe5a7fcfb79fc1f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createContext(null);



var $avTgU = parcelRequire("avTgU");
function $c681947e2b5cdc3e$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $avTgU.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $avTgU.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $c681947e2b5cdc3e$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $c681947e2b5cdc3e$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $c681947e2b5cdc3e$export$fa71e2345c31d7a2(props, onExited) {
    return $c681947e2b5cdc3e$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $avTgU.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            "in": true,
            appear: $c681947e2b5cdc3e$var$getProp(child, 'appear', props),
            enter: $c681947e2b5cdc3e$var$getProp(child, 'enter', props),
            exit: $c681947e2b5cdc3e$var$getProp(child, 'exit', props)
        });
    });
}
function $c681947e2b5cdc3e$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $c681947e2b5cdc3e$export$bbc8a025727ea824(nextProps.children);
    var children = $c681947e2b5cdc3e$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $avTgU.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $avTgU.isValidElement)(prevChild) && !prevChild.props["in"]; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $avTgU.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            "in": true,
            exit: $c681947e2b5cdc3e$var$getProp(child, 'exit', nextProps),
            enter: $c681947e2b5cdc3e$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $avTgU.cloneElement)(child, {
            "in": false
        });
        else if (hasNext && hasPrev && (0, $avTgU.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $avTgU.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            "in": prevChild.props["in"],
            exit: $c681947e2b5cdc3e$var$getProp(child, 'exit', nextProps),
            enter: $c681947e2b5cdc3e$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $ab8d4a35ff561f1b$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $ab8d4a35ff561f1b$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $ab8d4a35ff561f1b$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $01f44fff890f6869$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $c1ba359986f6d8c1$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $c681947e2b5cdc3e$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $c681947e2b5cdc3e$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $c681947e2b5cdc3e$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $d09d16700cb2a0b8$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $ee247bcca180bf14$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $ab8d4a35ff561f1b$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createElement((0, $dfe5a7fcfb79fc1f$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createElement((0, $dfe5a7fcfb79fc1f$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).Component);
$ab8d4a35ff561f1b$var$TransitionGroup.propTypes = {};
$ab8d4a35ff561f1b$var$TransitionGroup.defaultProps = $ab8d4a35ff561f1b$var$defaultProps;
var $ab8d4a35ff561f1b$export$2e2bcd8739ae039 = $ab8d4a35ff561f1b$var$TransitionGroup;





var $avTgU = parcelRequire("avTgU");



var $d093d321bc70301c$var$useEnhancedEffect = typeof window === 'undefined' ? $avTgU.useEffect : $avTgU.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $d093d321bc70301c$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props["in"], _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function onExited() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $avTgU.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $ba1853cec4ff049d$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $d093d321bc70301c$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $avTgU.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $avTgU.createElement("span", {
        className: childClassName
    }));
}
var $d093d321bc70301c$export$2e2bcd8739ae039 = $d093d321bc70301c$var$Ripple;


var $0a72bf7ac71dd0fd$var$DURATION = 550;
var $0a72bf7ac71dd0fd$export$95d0c9356b2231a3 = 80;
var $0a72bf7ac71dd0fd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: 'inherit'
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: 'absolute'
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: 'scale(1)',
            animation: "$enter ".concat($0a72bf7ac71dd0fd$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($0a72bf7ac71dd0fd$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: 'absolute',
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        '@keyframes enter': {
            '0%': {
                transform: 'scale(0)',
                opacity: 0.1
            },
            '100%': {
                transform: 'scale(1)',
                opacity: 0.3
            }
        },
        '@keyframes exit': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        '@keyframes pulsate': {
            '0%': {
                transform: 'scale(1)'
            },
            '50%': {
                transform: 'scale(0.92)'
            },
            '100%': {
                transform: 'scale(1)'
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $0a72bf7ac71dd0fd$var$TouchRipple = /*#__PURE__*/ $avTgU.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $avTgU.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $avTgU.useRef(0);
    var rippleCallback = $avTgU.useRef(null);
    $avTgU.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $avTgU.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $avTgU.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $avTgU.useRef(null);
    var container = $avTgU.useRef(null);
    $avTgU.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $avTgU.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $2f46c3e0b8783927$export$2e2bcd8739ae039)(oldRipples), [
                /*#__PURE__*/ $avTgU.createElement((0, $d093d321bc70301c$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $0a72bf7ac71dd0fd$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $avTgU.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === 'touchstart') ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $0a72bf7ac71dd0fd$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $avTgU.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $avTgU.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === 'touchend' && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $avTgU.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $avTgU.createElement("span", (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $avTgU.createElement((0, $ab8d4a35ff561f1b$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $0a72bf7ac71dd0fd$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($0a72bf7ac71dd0fd$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiTouchRipple'
})(/*#__PURE__*/ $avTgU.memo($0a72bf7ac71dd0fd$var$TouchRipple));


var $e47a5130f97b843e$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$disabled': {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $e47a5130f97b843e$var$ButtonBase = /*#__PURE__*/ $avTgU.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $avTgU.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $b4e3bc3b27e4fc4b$exports.findDOMNode(buttonRef.current);
    }
    var rippleRef = $avTgU.useRef(null);
    var _React$useState = $avTgU.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $8a3cf8c663a4fdf5$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $avTgU.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $avTgU.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $ba1853cec4ff049d$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $ba1853cec4ff049d$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $avTgU.useRef(false);
    var handleKeyDown = (0, $ba1853cec4ff049d$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $ba1853cec4ff049d$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === 'button' && other.href) ComponentProp = 'a';
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== 'a' || !other.href) buttonProps.role = 'button';
        buttonProps['aria-disabled'] = disabled;
    }
    var handleUserRef = (0, $51a416293b736e3c$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $51a416293b736e3c$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $51a416293b736e3c$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $avTgU.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $avTgU.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $avTgU.createElement(ComponentProp, (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $avTgU.createElement((0, $0a72bf7ac71dd0fd$export$2e2bcd8739ae039), (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $e47a5130f97b843e$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($e47a5130f97b843e$export$9dd6ff9ea0189349, {
    name: 'MuiButtonBase'
})($e47a5130f97b843e$var$ButtonBase);



function $d7a06bc8ed8b6e35$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $251b2509b429bc46$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}


var $1a3150ef2d936fbd$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({}, theme.typography.button, {
            boxSizing: 'border-box',
            minWidth: 64,
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                'background-color',
                'box-shadow',
                'border'
            ], {
                duration: theme.transitions.duration["short"]
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: '6px 8px'
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: '5px 15px',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.primary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.secondary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            '&:hover': {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                '&$disabled': {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            '&$focusVisible': {
                boxShadow: theme.shadows[6]
            },
            '&:active': {
                boxShadow: theme.shadows[8]
            },
            '&$disabled': {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&$focusVisible': {
                boxShadow: 'none'
            },
            '&:active': {
                boxShadow: 'none'
            },
            '&$disabled': {
                boxShadow: 'none'
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit',
            borderColor: 'currentColor'
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: '4px 5px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: '8px 11px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: '3px 9px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: '7px 21px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: '4px 10px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: '8px 22px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: 'inherit',
            marginRight: 8,
            marginLeft: -4,
            '&$iconSizeSmall': {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: 'inherit',
            marginRight: -4,
            marginLeft: 8,
            '&$iconSizeSmall': {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            '& > *:first-child': {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            '& > *:first-child': {
                fontSize: 22
            }
        }
    };
};
var $1a3150ef2d936fbd$var$Button = /*#__PURE__*/ $avTgU.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? 'text' : _props$variant, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $avTgU.createElement("span", {
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.startIcon, classes["iconSize".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $avTgU.createElement("span", {
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.endIcon, classes["iconSize".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $avTgU.createElement((0, $e47a5130f97b843e$export$2e2bcd8739ae039), (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(color))], size !== 'medium' && [
            classes["".concat(variant, "Size").concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(size))],
            classes["size".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $avTgU.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $1a3150ef2d936fbd$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($1a3150ef2d936fbd$export$9dd6ff9ea0189349, {
    name: 'MuiButton'
})($1a3150ef2d936fbd$var$Button);




var $avTgU = parcelRequire("avTgU");




var $avTgU = parcelRequire("avTgU");

var $avTgU = parcelRequire("avTgU");
/**
 * @ignore - internal component.
 */ var $5c9b242946c06e68$var$FormControlContext = $avTgU.createContext();
function $5c9b242946c06e68$export$62ecd8ad1bbe1a18() {
    return $avTgU.useContext($5c9b242946c06e68$var$FormControlContext);
}
var $5c9b242946c06e68$export$2e2bcd8739ae039 = $5c9b242946c06e68$var$FormControlContext;


function $857efbc8f4340c8d$export$2e2bcd8739ae039() {
    return $avTgU.useContext((0, $5c9b242946c06e68$export$2e2bcd8739ae039));
}






var $avTgU = parcelRequire("avTgU");




var $90cd669c180be83d$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            margin: 0
        },
        /* Styles applied to the root element if `variant="body2"`. */ body2: theme.typography.body2,
        /* Styles applied to the root element if `variant="body1"`. */ body1: theme.typography.body1,
        /* Styles applied to the root element if `variant="caption"`. */ caption: theme.typography.caption,
        /* Styles applied to the root element if `variant="button"`. */ button: theme.typography.button,
        /* Styles applied to the root element if `variant="h1"`. */ h1: theme.typography.h1,
        /* Styles applied to the root element if `variant="h2"`. */ h2: theme.typography.h2,
        /* Styles applied to the root element if `variant="h3"`. */ h3: theme.typography.h3,
        /* Styles applied to the root element if `variant="h4"`. */ h4: theme.typography.h4,
        /* Styles applied to the root element if `variant="h5"`. */ h5: theme.typography.h5,
        /* Styles applied to the root element if `variant="h6"`. */ h6: theme.typography.h6,
        /* Styles applied to the root element if `variant="subtitle1"`. */ subtitle1: theme.typography.subtitle1,
        /* Styles applied to the root element if `variant="subtitle2"`. */ subtitle2: theme.typography.subtitle2,
        /* Styles applied to the root element if `variant="overline"`. */ overline: theme.typography.overline,
        /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */ srOnly: {
            position: 'absolute',
            height: 1,
            width: 1,
            overflow: 'hidden'
        },
        /* Styles applied to the root element if `align="left"`. */ alignLeft: {
            textAlign: 'left'
        },
        /* Styles applied to the root element if `align="center"`. */ alignCenter: {
            textAlign: 'center'
        },
        /* Styles applied to the root element if `align="right"`. */ alignRight: {
            textAlign: 'right'
        },
        /* Styles applied to the root element if `align="justify"`. */ alignJustify: {
            textAlign: 'justify'
        },
        /* Styles applied to the root element if `nowrap={true}`. */ noWrap: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        /* Styles applied to the root element if `gutterBottom={true}`. */ gutterBottom: {
            marginBottom: '0.35em'
        },
        /* Styles applied to the root element if `paragraph={true}`. */ paragraph: {
            marginBottom: 16
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="textPrimary"`. */ colorTextPrimary: {
            color: theme.palette.text.primary
        },
        /* Styles applied to the root element if `color="textSecondary"`. */ colorTextSecondary: {
            color: theme.palette.text.secondary
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `display="inline"`. */ displayInline: {
            display: 'inline'
        },
        /* Styles applied to the root element if `display="block"`. */ displayBlock: {
            display: 'block'
        }
    };
};
var $90cd669c180be83d$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p'
};
var $90cd669c180be83d$var$Typography = /*#__PURE__*/ $avTgU.forwardRef(function Typography(props, ref) {
    var _props$align = props.align, align = _props$align === void 0 ? 'inherit' : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'initial' : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? 'initial' : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? 'body1' : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? $90cd669c180be83d$var$defaultVariantMapping : _props$variantMapping, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "align",
        "classes",
        "className",
        "color",
        "component",
        "display",
        "gutterBottom",
        "noWrap",
        "paragraph",
        "variant",
        "variantMapping"
    ]);
    var Component = component || (paragraph ? 'p' : variantMapping[variant] || $90cd669c180be83d$var$defaultVariantMapping[variant]) || 'span';
    return /*#__PURE__*/ $avTgU.createElement(Component, (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(align))], display !== 'initial' && classes["display".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(display))]),
        ref: ref
    }, other));
});
var $90cd669c180be83d$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($90cd669c180be83d$export$9dd6ff9ea0189349, {
    name: 'MuiTypography'
})($90cd669c180be83d$var$Typography);



var $f9fc4b0a1344f6ce$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            // For correct alignment with the text.
            verticalAlign: 'middle',
            WebkitTapHighlightColor: 'transparent',
            marginLeft: -11,
            marginRight: 16,
            // used for row presentation of radio/checkbox
            '&$disabled': {
                cursor: 'default'
            }
        },
        /* Styles applied to the root element if `labelPlacement="start"`. */ labelPlacementStart: {
            flexDirection: 'row-reverse',
            marginLeft: 16,
            // used for row presentation of radio/checkbox
            marginRight: -11
        },
        /* Styles applied to the root element if `labelPlacement="top"`. */ labelPlacementTop: {
            flexDirection: 'column-reverse',
            marginLeft: 16
        },
        /* Styles applied to the root element if `labelPlacement="bottom"`. */ labelPlacementBottom: {
            flexDirection: 'column',
            marginLeft: 16
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the label's Typography component. */ label: {
            '&$disabled': {
                color: theme.palette.text.disabled
            }
        }
    };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ var $f9fc4b0a1344f6ce$var$FormControlLabel = /*#__PURE__*/ $avTgU.forwardRef(function FormControlLabel(props, ref) {
    var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "checked",
        "classes",
        "className",
        "control",
        "disabled",
        "inputRef",
        "label",
        "labelPlacement",
        "name",
        "onChange",
        "value"
    ]);
    var muiFormControl = (0, $857efbc8f4340c8d$export$2e2bcd8739ae039)();
    var disabled = disabledProp;
    if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') disabled = control.props.disabled;
    if (typeof disabled === 'undefined' && muiFormControl) disabled = muiFormControl.disabled;
    var controlProps = {
        disabled: disabled
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach(function(key) {
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    return /*#__PURE__*/ $avTgU.createElement("label", (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(labelPlacement))], disabled && classes.disabled),
        ref: ref
    }, other), /*#__PURE__*/ $avTgU.cloneElement(control, controlProps), /*#__PURE__*/ $avTgU.createElement((0, $90cd669c180be83d$export$2e2bcd8739ae039), {
        component: "span",
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.label, disabled && classes.disabled)
    }, label));
});
var $f9fc4b0a1344f6ce$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($f9fc4b0a1344f6ce$export$9dd6ff9ea0189349, {
    name: 'MuiFormControlLabel'
})($f9fc4b0a1344f6ce$var$FormControlLabel);





var $avTgU = parcelRequire("avTgU");




function $0bee913edef143ae$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $8b9da86d6252bcfd$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $36bb892374e862ac$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $4219831b2992df4c$export$2e2bcd8739ae039(r, e) {
    return (0, $0bee913edef143ae$export$2e2bcd8739ae039)(r) || (0, $8b9da86d6252bcfd$export$2e2bcd8739ae039)(r, e) || (0, $a41cd76cdb05f258$export$2e2bcd8739ae039)(r, e) || (0, $36bb892374e862ac$export$2e2bcd8739ae039)();
}




var $avTgU = parcelRequire("avTgU");



/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ 
var $avTgU = parcelRequire("avTgU");
function $89f01047067df639$export$2e2bcd8739ae039(_ref) {
    var controlled = _ref.controlled, defaultProp = _ref["default"], name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? 'value' : _ref$state;
    var _React$useRef = $avTgU.useRef(controlled !== undefined), isControlled = _React$useRef.current;
    var _React$useState = $avTgU.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
    var value = isControlled ? controlled : valueState;
    var _React$useRef2, defaultValue;
    var setValueIfUncontrolled = $avTgU.useCallback(function(newValue) {
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}







var $avTgU = parcelRequire("avTgU");







var $226d3ce756820105$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            textAlign: 'center',
            flex: '0 0 auto',
            fontSize: theme.typography.pxToRem(24),
            padding: 12,
            borderRadius: '50%',
            overflow: 'visible',
            // Explicitly set the default value to solve a bug on IE 11.
            color: theme.palette.action.active,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.shortest
            }),
            '&:hover': {
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                backgroundColor: 'transparent',
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `edge="start"`. */ edgeStart: {
            marginLeft: -12,
            '$sizeSmall&': {
                marginLeft: -3
            }
        },
        /* Styles applied to the root element if `edge="end"`. */ edgeEnd: {
            marginRight: -12,
            '$sizeSmall&': {
                marginRight: -3
            }
        },
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit'
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {
            padding: 3,
            fontSize: theme.typography.pxToRem(18)
        },
        /* Styles applied to the children container element. */ label: {
            width: '100%',
            display: 'flex',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        }
    };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */ var $226d3ce756820105$var$IconButton = /*#__PURE__*/ $avTgU.forwardRef(function IconButton(props, ref) {
    var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "edge",
        "children",
        "classes",
        "className",
        "color",
        "disabled",
        "disableFocusRipple",
        "size"
    ]);
    return /*#__PURE__*/ $avTgU.createElement((0, $e47a5130f97b843e$export$2e2bcd8739ae039), (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, className, color !== 'default' && classes["color".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(size))], {
            start: classes.edgeStart,
            end: classes.edgeEnd
        }[edge]),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other), /*#__PURE__*/ $avTgU.createElement("span", {
        className: classes.label
    }, children));
});
var $226d3ce756820105$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($226d3ce756820105$export$9dd6ff9ea0189349, {
    name: 'MuiIconButton'
})($226d3ce756820105$var$IconButton);


var $df652c6464ae5311$export$9dd6ff9ea0189349 = {
    root: {
        padding: 9
    },
    checked: {},
    disabled: {},
    input: {
        cursor: 'inherit',
        position: 'absolute',
        opacity: 0,
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        margin: 0,
        padding: 0,
        zIndex: 1
    }
};
/**
 * @ignore - internal component.
 */ var $df652c6464ae5311$var$SwitchBase = /*#__PURE__*/ $avTgU.forwardRef(function SwitchBase(props, ref) {
    var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "autoFocus",
        "checked",
        "checkedIcon",
        "classes",
        "className",
        "defaultChecked",
        "disabled",
        "icon",
        "id",
        "inputProps",
        "inputRef",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "readOnly",
        "required",
        "tabIndex",
        "type",
        "value"
    ]);
    var _useControlled = (0, $89f01047067df639$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        "default": Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    }), _useControlled2 = (0, $4219831b2992df4c$export$2e2bcd8739ae039)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
    var muiFormControl = (0, $857efbc8f4340c8d$export$2e2bcd8739ae039)();
    var handleFocus = function handleFocus(event) {
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    var handleBlur = function handleBlur(event) {
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    var handleInputChange = function handleInputChange(event) {
        var newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v5: remove the second argument.
        onChange(event, newChecked);
    };
    var disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    var hasLabelFor = type === 'checkbox' || type === 'radio';
    return /*#__PURE__*/ $avTgU.createElement((0, $226d3ce756820105$export$2e2bcd8739ae039), (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        component: "span",
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ref: ref
    }, other), /*#__PURE__*/ $avTgU.createElement("input", (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        autoFocus: autoFocus,
        checked: checkedProp,
        defaultChecked: defaultChecked,
        className: classes.input,
        disabled: disabled,
        id: hasLabelFor && id,
        name: name,
        onChange: handleInputChange,
        readOnly: readOnly,
        ref: inputRef,
        required: required,
        tabIndex: tabIndex,
        type: type,
        value: value
    }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
var $df652c6464ae5311$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($df652c6464ae5311$export$9dd6ff9ea0189349, {
    name: 'PrivateSwitchBase'
})($df652c6464ae5311$var$SwitchBase);



var $avTgU = parcelRequire("avTgU");


var $avTgU = parcelRequire("avTgU");



var $avTgU = parcelRequire("avTgU");





var $b929c73ae63fb024$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            userSelect: 'none',
            width: '1em',
            height: '1em',
            display: 'inline-block',
            fill: 'currentColor',
            flexShrink: 0,
            fontSize: theme.typography.pxToRem(24),
            transition: theme.transitions.create('fill', {
                duration: theme.transitions.duration.shorter
            })
        },
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            color: theme.palette.primary.main
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            color: theme.palette.secondary.main
        },
        /* Styles applied to the root element if `color="action"`. */ colorAction: {
            color: theme.palette.action.active
        },
        /* Styles applied to the root element if `color="error"`. */ colorError: {
            color: theme.palette.error.main
        },
        /* Styles applied to the root element if `color="disabled"`. */ colorDisabled: {
            color: theme.palette.action.disabled
        },
        /* Styles applied to the root element if `fontSize="inherit"`. */ fontSizeInherit: {
            fontSize: 'inherit'
        },
        /* Styles applied to the root element if `fontSize="small"`. */ fontSizeSmall: {
            fontSize: theme.typography.pxToRem(20)
        },
        /* Styles applied to the root element if `fontSize="large"`. */ fontSizeLarge: {
            fontSize: theme.typography.pxToRem(35)
        }
    };
};
var $b929c73ae63fb024$var$SvgIcon = /*#__PURE__*/ $avTgU.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'inherit' : _props$color, _props$component = props.component, Component = _props$component === void 0 ? 'svg' : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "fontSize",
        "htmlColor",
        "titleAccess",
        "viewBox"
    ]);
    return /*#__PURE__*/ $avTgU.createElement(Component, (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        className: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, className, color !== 'inherit' && classes["color".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(fontSize))]),
        focusable: "false",
        viewBox: viewBox,
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, other), children, titleAccess ? /*#__PURE__*/ $avTgU.createElement("title", null, titleAccess) : null);
});
$b929c73ae63fb024$var$SvgIcon.muiName = 'SvgIcon';
var $b929c73ae63fb024$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($b929c73ae63fb024$export$9dd6ff9ea0189349, {
    name: 'MuiSvgIcon'
})($b929c73ae63fb024$var$SvgIcon);


function $288adca55b7caf8d$export$2e2bcd8739ae039(path, displayName) {
    var Component = function Component(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createElement((0, $b929c73ae63fb024$export$2e2bcd8739ae039), (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
            ref: ref
        }, props), path);
    };
    Component.muiName = (0, $b929c73ae63fb024$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).forwardRef(Component));
}


var /**
 * @ignore - internal component.
 */ $f492f28f7885c9b6$export$2e2bcd8739ae039 = (0, $288adca55b7caf8d$export$2e2bcd8739ae039)(/*#__PURE__*/ $avTgU.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');



var $avTgU = parcelRequire("avTgU");

var /**
 * @ignore - internal component.
 */ $313403ef99c636f1$export$2e2bcd8739ae039 = (0, $288adca55b7caf8d$export$2e2bcd8739ae039)(/*#__PURE__*/ $avTgU.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');




var $avTgU = parcelRequire("avTgU");

var /**
 * @ignore - internal component.
 */ $40868b28730b757c$export$2e2bcd8739ae039 = (0, $288adca55b7caf8d$export$2e2bcd8739ae039)(/*#__PURE__*/ $avTgU.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');




var $e5233ec96a6e573c$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            color: theme.palette.text.secondary
        },
        /* Pseudo-class applied to the root element if `checked={true}`. */ checked: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Pseudo-class applied to the root element if `indeterminate={true}`. */ indeterminate: {},
        /* Styles applied to the root element if `color="primary"`. */ colorPrimary: {
            '&$checked': {
                color: theme.palette.primary.main,
                '&:hover': {
                    backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        },
        /* Styles applied to the root element if `color="secondary"`. */ colorSecondary: {
            '&$checked': {
                color: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: (0, $53c8c435ad2b1764$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: 'transparent'
                    }
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }
    };
};
var $e5233ec96a6e573c$var$defaultCheckedIcon = /*#__PURE__*/ $avTgU.createElement((0, $313403ef99c636f1$export$2e2bcd8739ae039), null);
var $e5233ec96a6e573c$var$defaultIcon = /*#__PURE__*/ $avTgU.createElement((0, $f492f28f7885c9b6$export$2e2bcd8739ae039), null);
var $e5233ec96a6e573c$var$defaultIndeterminateIcon = /*#__PURE__*/ $avTgU.createElement((0, $40868b28730b757c$export$2e2bcd8739ae039), null);
var $e5233ec96a6e573c$var$Checkbox = /*#__PURE__*/ $avTgU.forwardRef(function Checkbox(props, ref) {
    var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? $e5233ec96a6e573c$var$defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? 'secondary' : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? $e5233ec96a6e573c$var$defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? $e5233ec96a6e573c$var$defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, other = (0, $de52adba366158be$export$2e2bcd8739ae039)(props, [
        "checkedIcon",
        "classes",
        "color",
        "icon",
        "indeterminate",
        "indeterminateIcon",
        "inputProps",
        "size"
    ]);
    var icon = indeterminate ? indeterminateIconProp : iconProp;
    var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    return /*#__PURE__*/ $avTgU.createElement((0, $df652c6464ae5311$export$2e2bcd8739ae039), (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        type: "checkbox",
        classes: {
            root: (0, $f3c76fa91a7d4fc8$export$2e2bcd8739ae039)(classes.root, classes["color".concat((0, $d7a06bc8ed8b6e35$export$2e2bcd8739ae039)(color))], indeterminate && classes.indeterminate),
            checked: classes.checked,
            disabled: classes.disabled
        },
        color: color,
        inputProps: (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $avTgU.cloneElement(icon, {
            fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
        }),
        checkedIcon: /*#__PURE__*/ $avTgU.cloneElement(indeterminateIcon, {
            fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
        }),
        ref: ref
    }, other));
});
var $e5233ec96a6e573c$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($e5233ec96a6e573c$export$9dd6ff9ea0189349, {
    name: 'MuiCheckbox'
})($e5233ec96a6e573c$var$Checkbox);




var $avTgU = parcelRequire("avTgU");



var $3c79124f418d8393$export$c0bb0b647f701bb5 = {
    WebkitFontSmoothing: 'antialiased',
    // Antialiasing.
    MozOsxFontSmoothing: 'grayscale',
    // Antialiasing.
    // Change from `box-sizing: content-box` so that `width`
    // is not affected by `padding` or `border`.
    boxSizing: 'border-box'
};
var $3c79124f418d8393$export$32180ef41b15b513 = function body(theme) {
    return (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
        color: theme.palette.text.primary
    }, theme.typography.body2, {
        backgroundColor: theme.palette.background["default"],
        '@media print': {
            // Save printer ink.
            backgroundColor: theme.palette.common.white
        }
    });
};
var $3c79124f418d8393$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        '@global': {
            html: $3c79124f418d8393$export$c0bb0b647f701bb5,
            '*, *::before, *::after': {
                boxSizing: 'inherit'
            },
            'strong, b': {
                fontWeight: theme.typography.fontWeightBold
            },
            body: (0, $1223d5492c6f7a02$export$2e2bcd8739ae039)({
                margin: 0
            }, $3c79124f418d8393$export$32180ef41b15b513(theme), {
                // Add support for document.body.requestFullScreen().
                // Other elements, if background transparent, are not supported.
                '&::backdrop': {
                    backgroundColor: theme.palette.background["default"]
                }
            })
        }
    };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $3c79124f418d8393$var$CssBaseline(props) {
    /* eslint-disable no-unused-vars */ var _props$children = props.children, children = _props$children === void 0 ? null : _props$children, classes = props.classes;
    /* eslint-enable no-unused-vars */ return /*#__PURE__*/ $avTgU.createElement($avTgU.Fragment, null, children);
}
var $3c79124f418d8393$export$2e2bcd8739ae039 = (0, $1431f684f949e5cb$export$2e2bcd8739ae039)($3c79124f418d8393$export$9dd6ff9ea0189349, {
    name: 'MuiCssBaseline'
})($3c79124f418d8393$var$CssBaseline);




var $avTgU = parcelRequire("avTgU");





function $0fc62eee64133f40$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        var mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $5a5e3108410ead6b$export$2e2bcd8739ae039)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $0fc62eee64133f40$var$ThemeProvider(props) {
    var children = props.children, localTheme = props.theme;
    var outerTheme = (0, $08dbfbd2a34dd470$export$2e2bcd8739ae039)();
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).useMemo(function() {
        var output = outerTheme === null ? localTheme : $0fc62eee64133f40$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $ee6d210aea3c3a6a$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($avTgU))).createElement((0, $75cbcca4f0a1891c$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, children);
}
var $0fc62eee64133f40$export$2e2bcd8739ae039 = $0fc62eee64133f40$var$ThemeProvider;



var $avTgU = parcelRequire("avTgU");


function $4c5df0ea0c7cf371$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $95f600d7dc061357$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $7da987db92143a5e$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $60805d3ecaa1768c$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $7da987db92143a5e$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $avTgU = parcelRequire("avTgU");
var $067cce890ae285a7$export$5b40a4553fa23bdc = function(_param) {
    var text = _param.text, style = _param.style, props = (0, $60805d3ecaa1768c$export$71511d61b312f219)(_param, [
        "text",
        "style"
    ]);
    return /*#__PURE__*/ $avTgU.createElement("div", (0, $4c5df0ea0c7cf371$export$71511d61b312f219)({
        style: (0, $4c5df0ea0c7cf371$export$71511d61b312f219)({
            backgroundColor: '#E8F1FD',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 600,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            color: '#1A73E8',
            display: 'inline-flex'
        }, style),
        role: "status",
        "aria-label": "Beta version indicator"
    }, props), text || 'beta');
};


var $7ede20810891f9e0$export$a30baa0788bcde29 = function() {
    return /*#__PURE__*/ $avTgU.createElement("article", {
        style: {
            display: 'flex',
            maxWidth: '308px',
            flexDirection: 'column',
            fontFamily: 'Inter, sans-serif',
            justifyContent: 'start',
            outline: 'none'
        },
        role: "region",
        "aria-labelledby": "plugin-title"
    }, /*#__PURE__*/ $avTgU.createElement("img", {
        loading: "lazy",
        src: "https://cdn.builder.io/api/v1/image/assets/f5348105e75441b59830f1e489577801/1f601258d25809d0bea9bd1f76688db5117fa97bd8c49bc01b24e2fe37939c4b?apiKey=f5348105e75441b59830f1e489577801&",
        alt: "Layout copy feature illustration",
        style: {
            aspectRatio: '1.36',
            objectFit: 'contain',
            objectPosition: 'center',
            width: '140px',
            borderRadius: '0px',
            alignSelf: 'center',
            maxWidth: '100%',
            cursor: 'default'
        }
    }), /*#__PURE__*/ $avTgU.createElement("section", {
        style: {
            display: 'flex',
            margin: '16px 0 0',
            width: '100%',
            flexDirection: 'column',
            justifyContent: 'start'
        }
    }, /*#__PURE__*/ $avTgU.createElement("h2", {
        id: "plugin-title",
        style: {
            color: 'var(--text-primary, #333)',
            fontSize: '18px',
            fontWeight: 600,
            lineHeight: 1.2,
            margin: 0
        }
    }, "Copy Layout"), /*#__PURE__*/ $avTgU.createElement("p", {
        style: {
            alignSelf: 'start',
            color: 'var(--text-secondary, #5C5C5C)',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            margin: '8px 0 0'
        }
    }, "Save time by copying layouts from the web directly into Builder or Figma")));
};
var $7ede20810891f9e0$var$primaryColor = 'rgb(26, 115, 235, 1)';
var $7ede20810891f9e0$var$primaryDarkColor = 'rgba(0, 82, 187, 1)';
var $7ede20810891f9e0$var$REVIEW_URL = 'https://chromewebstore.google.com/detail/builderio/cfldfgibklhmjhnkfighkbafbkbfcmij/reviews';
var $7ede20810891f9e0$var$theme = (0, $f5d42ee048d59524$export$c469355549431d9b)({
    palette: {
        primary: {
            main: $7ede20810891f9e0$var$primaryColor,
            dark: $7ede20810891f9e0$var$primaryDarkColor
        }
    },
    overrides: {
        MuiButton: {
            contained: {
                boxShadow: 'none !important',
                '&:active': {
                    boxShadow: 'none !important'
                }
            },
            root: {
                borderRadius: '6px',
                textTransform: 'capitalize',
                boxShadow: 'none',
                '&:active': {
                    boxShadow: 'none'
                },
                fontSize: '1rem',
                lineHeight: '1.75rem'
            }
        }
    }
});
var $7ede20810891f9e0$var$RootComponent = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $ab43615bc785b3d2$export$71511d61b312f219)(RootComponent, _React_Component);
    function RootComponent(props) {
        (0, $26f837ee4ed2baf2$export$71511d61b312f219)(this, RootComponent);
        var _this;
        var _this1;
        _this = (0, $74c4af31b578e7d9$export$71511d61b312f219)(this, RootComponent, [
            props
        ]), _this1 = _this, _this1.builderOutlineStylesClass = 'builder-outline-elements-style', _this1.builderEditClassName = 'builder-edit-extension', _this1.builderLogoSrc = 'https://cdn.builder.io/api/v1/image/assets%2FYJIGb4i01jvw0SRdL5Bt%2F1d1897131896467986b4bc5d9e8d3c6e', _this1.outlineElements = function() {
            var shouldOutline = _this1.state.outlineBuilderComponents;
            chrome.tabs.query({
                active: true,
                currentWindow: true
            }, function(tabs) {
                chrome.tabs.sendMessage(tabs[0].id, {
                    type: 'outlineElements',
                    payload: {
                        shouldOutline: shouldOutline,
                        builderOutlineStylesClass: 'builder-outline-elements-style',
                        builderEditClassName: 'builder-edit-extension'
                    }
                });
            });
        }, _this1.handleOutlineBuilderElementsClick = function(event) {
            var checked = Boolean(event.target.checked);
            chrome.storage.sync.set({
                outlineBuilderComponents: checked
            });
            _this1.setState({
                outlineBuilderComponents: checked
            }, function() {
                _this1.outlineElements();
            });
        }, _this1.copyLayout = function(event) {
            chrome.runtime.sendMessage({
                type: 'copyLayout',
                payload: {}
            }, function() {
                // Add an additional split second delay to make sure the window has closed to
                // we get an immediate hover event which manes the overlays show right away
                setTimeout(function() {
                    window.close();
                }, 100);
            });
        }, // Fusion Extension - Element selection functionality
        _this1.startFusionSelection = function() {
            chrome.runtime.sendMessage({
                type: 'START_SELECTION'
            }, function(response) {
                if (response && response.success) // Close popup immediately so user can interact with the page
                window.close();
                else console.error('Selection failed:', response);
            });
        }, _this1.captureAndCreateAgent = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $ab9acc49883b316d$export$71511d61b312f219)(function() {
                return (0, $56694a0b8260f85d$export$71511d61b312f219)(this, function(_state) {
                    if (!_this1.state.userPrompt.trim()) {
                        alert('Please enter a prompt describing what you want to change.');
                        return [
                            2
                        ];
                    }
                    try {
                        console.log("\uD83D\uDE80 Starting comprehensive data capture...");
                        // Step 1: Get selected element data
                        chrome.runtime.sendMessage({
                            type: 'GET_SELECTED_ELEMENT'
                        }, function(elementResponse) {
                            if (elementResponse && elementResponse.success && elementResponse.element) // Step 2: Capture screenshot
                            chrome.runtime.sendMessage({
                                type: 'CAPTURE_SCREENSHOT'
                            }, function(screenshotResponse) {
                                if (screenshotResponse && screenshotResponse.success) // Step 3: Capture DOM snapshot
                                chrome.runtime.sendMessage({
                                    type: 'CAPTURE_DOM_SNAPSHOT'
                                }, function(domResponse) {
                                    if (domResponse && domResponse.success) {
                                        // Generate unique ID and prepare comprehensive project data
                                        var htmlId = 'fusion_' + Date.now().toString(36) + Math.random().toString(36).substr(2);
                                        var projectData = {
                                            htmlId: htmlId,
                                            url: domResponse.data.url || window.location.href,
                                            timestamp: new Date().toISOString(),
                                            userPrompt: _this1.state.userPrompt.trim(),
                                            element: elementResponse.element,
                                            screenshot: screenshotResponse.data,
                                            domSnapshot: domResponse.data.domSnapshot,
                                            pageTitle: domResponse.data.pageTitle,
                                            message: 'AI Agent Task: "'.concat(_this1.state.userPrompt.trim(), '" for element: ').concat(elementResponse.element.tagName).concat(elementResponse.element.id ? '#' + elementResponse.element.id : '').concat(elementResponse.element.className ? '.' + elementResponse.element.className.split(' ').join('.') : '')
                                        };
                                        // Store in chrome storage
                                        chrome.storage.local.set((0, $95f600d7dc061357$export$71511d61b312f219)({}, "fusion_project_".concat(htmlId), projectData), function() {
                                            console.log("\uD83C\uDFAF AI Agent project data stored with ID:", htmlId);
                                            // Clear selection and reset UI
                                            chrome.runtime.sendMessage({
                                                type: 'CLEAR_SELECTION'
                                            });
                                            _this1.setState({
                                                fusionMode: false,
                                                promptMode: false,
                                                userPrompt: ''
                                            });
                                            // Open the AI agent interface
                                            var agentUrl = "https://builder.io/app/projects/extension-agent/".concat(htmlId);
                                            chrome.tabs.create({
                                                url: agentUrl
                                            });
                                            // Close popup only after successful agent creation
                                            setTimeout(function() {
                                                window.close();
                                            }, 1000);
                                        });
                                    } else {
                                        console.error("\u274C Failed to capture DOM snapshot:", domResponse);
                                        alert('Failed to capture page content. Please try again.');
                                    }
                                });
                                else {
                                    console.error("\u274C Failed to capture screenshot:", screenshotResponse);
                                    alert('Failed to capture screenshot. Please try again.');
                                }
                            });
                            else {
                                console.error("\u274C No element selected:", elementResponse);
                                alert('No element selected. Please select an element first.');
                            }
                        });
                    } catch (error) {
                        console.error("\u274C Failed to capture and store:", error);
                        alert('An error occurred. Please try again.');
                    }
                    return [
                        2
                    ];
                });
            })();
        }, _this1.checkFusionState = function() {
            chrome.runtime.sendMessage({
                type: 'GET_SELECTED_ELEMENT'
            }, function(response) {
                if (response && response.success && response.element) _this1.setState({
                    fusionMode: true,
                    promptMode: true
                });
            });
        }, _this1.handleReviewClick = function() {
            chrome.tabs.create({
                url: $7ede20810891f9e0$var$REVIEW_URL
            });
            chrome.storage.local.set({
                reviewPromptDismissed: true
            });
            _this1.setState({
                showReviewPrompt: false
            });
        }, _this1.dismissReviewPrompt = function() {
            chrome.storage.local.set({
                reviewPromptDismissed: true
            });
            _this1.setState({
                showReviewPrompt: false
            });
        }, _this1.handleHideAgentIntroChange = function(event) {
            var hideAgentIntro = event.target.checked;
            chrome.storage.local.set({
                hideAgentIntro: hideAgentIntro
            });
            _this1.setState({
                hideAgentIntro: hideAgentIntro
            });
        }, _this1.renderHeader = function() {
            var headerStyle = {
                display: 'flex',
                alignItems: 'center',
                padding: '16px 20px',
                margin: '0 -30px',
                borderBottom: '1px solid #e0e0e0'
            };
            return /*#__PURE__*/ $avTgU.createElement("div", {
                style: headerStyle
            }, /*#__PURE__*/ $avTgU.createElement("img", {
                src: "icons/builder-logo.svg",
                alt: "Builder.io",
                style: {
                    height: '20px',
                    width: 'auto'
                }
            }));
        }, _this1.renderTabUI = function() {
            var activeTab = _this1.state.activeTab;
            var tabStyle = {
                display: 'flex',
                gap: '20px',
                alignItems: 'center',
                margin: '0 -30px 20px',
                padding: '0 20px'
            };
            var tabItemStyle = function(isActive) {
                return {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    paddingTop: '15px',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    cursor: 'pointer'
                };
            };
            var tabTextStyle = function(isActive) {
                return {
                    fontSize: '14px',
                    fontWeight: isActive ? 600 : 500,
                    lineHeight: '20px',
                    color: isActive ? '#333' : '#909090',
                    textAlign: 'center'
                };
            };
            var tabUnderlineStyle = function(isActive) {
                return {
                    width: '100%',
                    height: '2px',
                    backgroundColor: isActive ? $7ede20810891f9e0$var$primaryColor : 'transparent'
                };
            };
            return /*#__PURE__*/ $avTgU.createElement($avTgU.Fragment, null, _this1.renderHeader(), /*#__PURE__*/ $avTgU.createElement("div", {
                style: tabStyle
            }, /*#__PURE__*/ $avTgU.createElement("div", {
                style: tabItemStyle(activeTab === 'copy'),
                onClick: function() {
                    _this1.setState({
                        activeTab: 'copy'
                    });
                    chrome.storage.local.set({
                        activeTab: 'copy'
                    });
                }
            }, /*#__PURE__*/ $avTgU.createElement("span", {
                style: tabTextStyle(activeTab === 'copy')
            }, "Copy Layout"), /*#__PURE__*/ $avTgU.createElement("div", {
                style: tabUnderlineStyle(activeTab === 'copy')
            })), /*#__PURE__*/ $avTgU.createElement("div", {
                style: tabItemStyle(activeTab === 'agent'),
                onClick: function() {
                    _this1.setState({
                        activeTab: 'agent'
                    });
                    chrome.storage.local.set({
                        activeTab: 'agent'
                    });
                }
            }, /*#__PURE__*/ $avTgU.createElement("div", {
                style: {
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center'
                }
            }, /*#__PURE__*/ $avTgU.createElement("span", {
                style: tabTextStyle(activeTab === 'agent')
            }, "Builder Agent"), /*#__PURE__*/ $avTgU.createElement((0, $067cce890ae285a7$export$5b40a4553fa23bdc), {
                style: {
                    padding: '2px 4px',
                    fontSize: '11px',
                    fontWeight: 600,
                    lineHeight: '16px',
                    letterSpacing: '0.5px'
                }
            })), /*#__PURE__*/ $avTgU.createElement("div", {
                style: tabUnderlineStyle(activeTab === 'agent')
            }))));
        };
        _this1.state = {
            outlineBuilderComponents: false,
            fusionMode: false,
            promptMode: false,
            userPrompt: '',
            clickCount: 0,
            activeTab: 'copy',
            showReviewPrompt: false,
            hideAgentIntro: false
        };
        return _this;
    }
    (0, $5ae6d0425b58687e$export$71511d61b312f219)(RootComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                chrome.storage.sync.get([
                    'outlineBuilderComponents'
                ], function(data) {
                    _this.setState({
                        outlineBuilderComponents: Boolean(data.outlineBuilderComponents)
                    }, function() {
                        _this.outlineElements();
                    });
                });
                // Load AI Agent visibility setting and last selected tab from local storage
                chrome.storage.local.get([
                    'activeTab',
                    'popupOpenCount',
                    'reviewPromptDismissed',
                    'firstPopupOpenAt',
                    'hideAgentIntro'
                ], function(data) {
                    var now = Date.now();
                    var popupOpenCount = Number(data.popupOpenCount || 0) + 1;
                    var firstPopupOpenAt = Number(data.firstPopupOpenAt);
                    var shouldPersistFirstOpen = !data.firstPopupOpenAt || Number.isNaN(firstPopupOpenAt);
                    if (shouldPersistFirstOpen) firstPopupOpenAt = now;
                    var storageUpdate = {
                        popupOpenCount: popupOpenCount
                    };
                    if (shouldPersistFirstOpen) storageUpdate.firstPopupOpenAt = firstPopupOpenAt;
                    chrome.storage.local.set(storageUpdate);
                    var oneWeekMs = 604800000;
                    var hasWeekElapsed = now - firstPopupOpenAt >= oneWeekMs;
                    var shouldShowReview = !data.reviewPromptDismissed && popupOpenCount >= 4 && hasWeekElapsed;
                    _this.setState({
                        activeTab: data.activeTab || 'copy',
                        showReviewPrompt: shouldShowReview,
                        hideAgentIntro: Boolean(data.hideAgentIntro)
                    });
                });
                // Clear any badge notifications when popup opens
                try {
                    chrome.action.setBadgeText({
                        text: ''
                    });
                } catch (error) {
                    console.log('Could not clear badge:', error);
                }
                // Check if there's a selected element for fusion functionality
                this.checkFusionState();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ $avTgU.createElement((0, $0fc62eee64133f40$export$2e2bcd8739ae039), {
                    theme: $7ede20810891f9e0$var$theme
                }, /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        padding: '0 30px 0px 30px',
                        width: 380,
                        backgroundColor: 'white'
                    }
                }, /*#__PURE__*/ $avTgU.createElement((0, $3c79124f418d8393$export$2e2bcd8739ae039), null), /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        textAlign: 'center'
                    }
                }, this.state.promptMode && this.renderHeader(), !this.state.promptMode && this.renderTabUI(), !this.state.promptMode && this.state.activeTab === 'copy' && /*#__PURE__*/ $avTgU.createElement($avTgU.Fragment, null, /*#__PURE__*/ $avTgU.createElement($7ede20810891f9e0$export$a30baa0788bcde29, null), this.state.showReviewPrompt && /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        backgroundColor: '#F8FAFF',
                        border: '1px solid #E2E9F8',
                        borderRadius: '8px',
                        padding: '12px',
                        margin: '18px 0 0 0',
                        textAlign: 'left'
                    }
                }, /*#__PURE__*/ $avTgU.createElement("p", {
                    style: {
                        fontSize: '13px',
                        fontWeight: 600,
                        color: '#1f3d7a',
                        margin: '0 0 4px 0'
                    }
                }, "Enjoying Builder?"), /*#__PURE__*/ $avTgU.createElement("p", {
                    style: {
                        fontSize: '12px',
                        color: '#4f5b76',
                        margin: 0,
                        lineHeight: '18px'
                    }
                }, "We'd appreciate a quick Chrome Web Store review when you have a minute."), /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        display: 'flex',
                        gap: '8px',
                        flexWrap: 'wrap',
                        marginTop: '12px'
                    }
                }, /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    size: "small",
                    onClick: this.handleReviewClick
                }, "Leave a Review"), /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    variant: "text",
                    size: "small",
                    onClick: this.dismissReviewPrompt,
                    style: {
                        color: '#5f6368'
                    }
                }, "Not now"))), /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    style: {
                        marginTop: 30,
                        marginBottom: 10
                    },
                    fullWidth: true,
                    variant: "contained",
                    color: "primary",
                    onClick: this.copyLayout
                }, "Copy Layout"), /*#__PURE__*/ $avTgU.createElement((0, $f9fc4b0a1344f6ce$export$2e2bcd8739ae039), {
                    style: {
                        userSelect: 'none',
                        marginBottom: 15,
                        transform: 'scale(0.9)'
                    },
                    control: /*#__PURE__*/ $avTgU.createElement((0, $e5233ec96a6e573c$export$2e2bcd8739ae039), {
                        checked: this.state.outlineBuilderComponents,
                        onChange: this.handleOutlineBuilderElementsClick,
                        disableRipple: true,
                        color: "primary"
                    }),
                    label: "Outline Builder components"
                })), (!this.state.promptMode && this.state.activeTab === 'agent' || this.state.promptMode) && /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        marginTop: this.state.promptMode ? 0 : 0,
                        paddingTop: this.state.promptMode ? 0 : 0,
                        borderTop: 'none'
                    }
                }, !this.state.fusionMode ? /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '16px',
                        padding: '20px 0'
                    }
                }, /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '8px',
                        width: '100%'
                    }
                }, /*#__PURE__*/ $avTgU.createElement("h2", {
                    style: {
                        fontSize: '20px',
                        fontWeight: 600,
                        lineHeight: '24px',
                        color: '#333',
                        margin: 0,
                        textAlign: 'center'
                    }
                }, "Ship UI Changes Faster"), /*#__PURE__*/ $avTgU.createElement("p", {
                    style: {
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        color: '#5c5c5c',
                        margin: 0,
                        textAlign: 'center'
                    }
                }, "Select any element, describe what you want, and Builder will get a ready-to-review PR")), !this.state.hideAgentIntro && /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        backgroundColor: '#f5f5f5',
                        border: '1px solid #d5d5d5',
                        borderRadius: '8px',
                        padding: '16px',
                        width: '100%',
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                    }
                }, /*#__PURE__*/ $avTgU.createElement("p", {
                    style: {
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: '20px',
                        color: '#333',
                        margin: 0
                    }
                }, "How it works:"), /*#__PURE__*/ $avTgU.createElement("ol", {
                    style: {
                        fontSize: '14px',
                        fontWeight: 400,
                        lineHeight: '20px',
                        color: '#5c5c5c',
                        margin: 0,
                        paddingLeft: '21px',
                        textAlign: 'left'
                    }
                }, /*#__PURE__*/ $avTgU.createElement("li", null, "Select an element on the page"), /*#__PURE__*/ $avTgU.createElement("li", null, "Prompt a change you want to make"), /*#__PURE__*/ $avTgU.createElement("li", null, "Builder will start working on your code"), /*#__PURE__*/ $avTgU.createElement("li", null, "PR will be created for you to review")), /*#__PURE__*/ $avTgU.createElement((0, $f9fc4b0a1344f6ce$export$2e2bcd8739ae039), {
                    style: {
                        margin: 0,
                        userSelect: 'none'
                    },
                    control: /*#__PURE__*/ $avTgU.createElement((0, $e5233ec96a6e573c$export$2e2bcd8739ae039), {
                        checked: this.state.hideAgentIntro,
                        onChange: this.handleHideAgentIntroChange,
                        disableRipple: true,
                        size: "small",
                        style: {
                            padding: '0 8px 0 0',
                            color: '#d5d5d5'
                        }
                    }),
                    label: /*#__PURE__*/ $avTgU.createElement("span", {
                        style: {
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '20px',
                            color: '#5c5c5c'
                        }
                    }, "Don't show this again")
                })), /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '12px',
                        width: '100%'
                    }
                }, /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    style: {
                        padding: '8px 12px',
                        fontSize: '16px',
                        fontWeight: 500,
                        lineHeight: '24px'
                    },
                    fullWidth: true,
                    variant: "contained",
                    color: "primary",
                    onClick: this.startFusionSelection
                }, "Start"), /*#__PURE__*/ $avTgU.createElement("a", {
                    href: "https://www.builder.io/c/docs/fusion",
                    target: "_blank",
                    rel: "noopener noreferrer",
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '4px',
                        fontSize: '14px',
                        fontWeight: 500,
                        lineHeight: '20px',
                        color: $7ede20810891f9e0$var$primaryColor,
                        textDecoration: 'none',
                        padding: '6px 8px'
                    }
                }, /*#__PURE__*/ $avTgU.createElement("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                }, /*#__PURE__*/ $avTgU.createElement("path", {
                    d: "M13.5 9.75V14.25C13.5 14.6478 13.342 15.0294 13.0607 15.3107C12.7794 15.592 12.3978 15.75 12 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V6C2.25 5.60218 2.40804 5.22064 2.68934 4.93934C2.97064 4.65804 3.35218 4.5 3.75 4.5H8.25",
                    stroke: $7ede20810891f9e0$var$primaryColor,
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }), /*#__PURE__*/ $avTgU.createElement("path", {
                    d: "M11.25 2.25H15.75V6.75",
                    stroke: $7ede20810891f9e0$var$primaryColor,
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }), /*#__PURE__*/ $avTgU.createElement("path", {
                    d: "M7.5 10.5L15.75 2.25",
                    stroke: $7ede20810891f9e0$var$primaryColor,
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })), "Learn More"))) : !this.state.promptMode ? /*#__PURE__*/ $avTgU.createElement($avTgU.Fragment, null, /*#__PURE__*/ $avTgU.createElement("p", {
                    style: {
                        fontSize: '12px',
                        color: '#10b981',
                        margin: '0 0 10px 0',
                        fontWeight: 500,
                        lineHeight: '18px'
                    }
                }, "\u2705 Element selected successfully!", /*#__PURE__*/ $avTgU.createElement("br", null), "Ready to create your AI code agent?"), /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 8,
                        padding: '8px 16px',
                        fontSize: '14px'
                    },
                    fullWidth: true,
                    variant: "contained",
                    color: "primary",
                    onClick: function() {
                        return _this.setState({
                            promptMode: true
                        });
                    }
                }, "Create AI Agent"), /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    style: {
                        padding: '6px 16px',
                        fontSize: '13px'
                    },
                    fullWidth: true,
                    variant: "outlined",
                    onClick: function() {
                        chrome.runtime.sendMessage({
                            type: 'CLEAR_SELECTION'
                        });
                        _this.setState({
                            fusionMode: false
                        });
                    }
                }, "Cancel")) : /*#__PURE__*/ $avTgU.createElement($avTgU.Fragment, null, /*#__PURE__*/ $avTgU.createElement("p", {
                    style: {
                        fontSize: '12px',
                        color: '#333',
                        margin: '0 0 10px 0',
                        fontWeight: 500
                    }
                }, "What code changes do you want to make?"), /*#__PURE__*/ $avTgU.createElement("textarea", {
                    value: this.state.userPrompt,
                    onChange: function(e) {
                        return _this.setState({
                            userPrompt: e.target.value
                        });
                    },
                    onKeyDown: function(e) {
                        if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
                            e.preventDefault();
                            // Use currentTarget.value to avoid React state race condition
                            var currentValue = e.currentTarget.value;
                            if (currentValue.trim()) _this.captureAndCreateAgent();
                        }
                    },
                    placeholder: "e.g., Change this button to be red and add a hover effect...",
                    style: {
                        width: '100%',
                        minHeight: '80px',
                        padding: '8px',
                        fontSize: '13px',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        resize: 'vertical',
                        fontFamily: 'inherit',
                        marginBottom: '10px',
                        boxSizing: 'border-box'
                    },
                    maxLength: 500
                }), /*#__PURE__*/ $avTgU.createElement("div", {
                    style: {
                        fontSize: '11px',
                        color: '#666',
                        marginBottom: '10px'
                    }
                }, this.state.userPrompt.length, "/500 characters"), /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    style: {
                        marginBottom: 8,
                        padding: '8px 16px',
                        fontSize: '14px'
                    },
                    fullWidth: true,
                    variant: "contained",
                    color: "primary",
                    onClick: this.captureAndCreateAgent,
                    disabled: !this.state.userPrompt.trim()
                }, "Create AI Agent"), /*#__PURE__*/ $avTgU.createElement((0, $1a3150ef2d936fbd$export$2e2bcd8739ae039), {
                    style: {
                        padding: '6px 16px',
                        fontSize: '13px'
                    },
                    fullWidth: true,
                    variant: "outlined",
                    onClick: function() {
                        _this.setState({
                            promptMode: false,
                            userPrompt: ''
                        });
                    }
                }, "Back"))))));
            }
        }
    ]);
    return RootComponent;
}($avTgU.Component);
$b4e3bc3b27e4fc4b$exports.render(/*#__PURE__*/ $avTgU.createElement($7ede20810891f9e0$var$RootComponent, null), document.getElementById('root'));


//# sourceMappingURL=popup.9f562113.js.map
